webpackJsonp([114276838955818,60335399758886],{

/***/ 238:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"pathPrefix":"/2018/state-scorecard","siteMetadata":{"title":"The Commonwealth Fund - 2018 Scorecard on State Health System Performance","year":"2018","subtitle":"Scorecard on State Health System Performance","siteUrl":"https://interactives.commonwealthfund.org/2018/state-scorecard","siteDescription":"A state-by-state report measuring access to care, quality of care, health outcomes, and health disparities across the United States."}},"allThemesJson":{"edges":[{"node":{"theme_id":"1","title":"Rising death rates, high levels of obesity, and gaps in care are pressing challenges for states","path":"/states-under-stress","stat":{"suffix":"%","number":"50","text":"increase in deaths from suicide, alcohol, and drug use since 2005"}}},{"node":{"theme_id":"2","title":"Regional differences in performance persist, as do within-state disparities","path":"/the-divide-lives-on","stat":{"suffix":"x","number":"11","text":"greater pediatric asthma hospital admissions rate in New York than in Vermont"}}},{"node":{"theme_id":"3","title":"Many states are not getting good value for their health care dollars","path":"/not-good-value","stat":{"suffix":"%","number":"29","text":"of adults with job-based insurance received unneeded lower back imaging at diagnosis"}}},{"node":{"theme_id":"4","title":"States made progress in areas that were the target of efforts to improve","path":"/making-progress","stat":{"suffix":"%","number":"20","text":"reduction since 2011 in the share of adults who smoke"}}}]},"allStatesJson":{"edges":[{"node":{"id":"AL","title":"Alabama","url":"alabama","ranking":42}},{"node":{"id":"AK","title":"Alaska","url":"alaska","ranking":34}},{"node":{"id":"AZ","title":"Arizona","url":"arizona","ranking":29}},{"node":{"id":"AR","title":"Arkansas","url":"arkansas","ranking":47}},{"node":{"id":"CA","title":"California","url":"california","ranking":14}},{"node":{"id":"CO","title":"Colorado","url":"colorado","ranking":10}},{"node":{"id":"CT","title":"Connecticut","url":"connecticut","ranking":9}},{"node":{"id":"DE","title":"Delaware","url":"delaware","ranking":22}},{"node":{"id":"DC","title":"District of Columbia","url":"district_of_columbia","ranking":30}},{"node":{"id":"FL","title":"Florida","url":"florida","ranking":48}},{"node":{"id":"GA","title":"Georgia","url":"georgia","ranking":41}},{"node":{"id":"HI","title":"Hawaii","url":"hawaii","ranking":1}},{"node":{"id":"ID","title":"Idaho","url":"idaho","ranking":14}},{"node":{"id":"IL","title":"Illinois","url":"illinois","ranking":26}},{"node":{"id":"IN","title":"Indiana","url":"indiana","ranking":37}},{"node":{"id":"IA","title":"Iowa","url":"iowa","ranking":6}},{"node":{"id":"KS","title":"Kansas","url":"kansas","ranking":32}},{"node":{"id":"KY","title":"Kentucky","url":"kentucky","ranking":42}},{"node":{"id":"LA","title":"Louisiana","url":"louisiana","ranking":49}},{"node":{"id":"ME","title":"Maine","url":"maine","ranking":16}},{"node":{"id":"MD","title":"Maryland","url":"maryland","ranking":20}},{"node":{"id":"MA","title":"Massachusetts","url":"massachusetts","ranking":2}},{"node":{"id":"MI","title":"Michigan","url":"michigan","ranking":27}},{"node":{"id":"MN","title":"Minnesota","url":"minnesota","ranking":3}},{"node":{"id":"MS","title":"Mississippi","url":"mississippi","ranking":51}},{"node":{"id":"MO","title":"Missouri","url":"missouri","ranking":44}},{"node":{"id":"MT","title":"Montana","url":"montana","ranking":19}},{"node":{"id":"NE","title":"Nebraska","url":"nebraska","ranking":21}},{"node":{"id":"NV","title":"Nevada","url":"nevada","ranking":39}},{"node":{"id":"NH","title":"New Hampshire","url":"new-hampshire","ranking":10}},{"node":{"id":"NJ","title":"New Jersey","url":"new-jersey","ranking":25}},{"node":{"id":"NM","title":"New Mexico","url":"new-mexico","ranking":31}},{"node":{"id":"NY","title":"New York","url":"new-york","ranking":18}},{"node":{"id":"NC","title":"North Carolina","url":"north-carolina","ranking":35}},{"node":{"id":"ND","title":"North Dakota","url":"north-dakota","ranking":23}},{"node":{"id":"OH","title":"Ohio","url":"ohio","ranking":36}},{"node":{"id":"OK","title":"Oklahoma","url":"oklahoma","ranking":50}},{"node":{"id":"OR","title":"Oregon","url":"oregon","ranking":13}},{"node":{"id":"PA","title":"Pennsylvania","url":"pennsylvania","ranking":23}},{"node":{"id":"RI","title":"Rhode Island","url":"rhode-island","ranking":10}},{"node":{"id":"SC","title":"South Carolina","url":"south-carolina","ranking":38}},{"node":{"id":"SD","title":"South Dakota","url":"south-dakota","ranking":16}},{"node":{"id":"TN","title":"Tennessee","url":"tennessee","ranking":49}},{"node":{"id":"TX","title":"Texas","url":"texas","ranking":44}},{"node":{"id":"UT","title":"Utah","url":"utah","ranking":5}},{"node":{"id":"VT","title":"Vermont","url":"vermont","ranking":4}},{"node":{"id":"VA","title":"Virginia","url":"virginia","ranking":28}},{"node":{"id":"WA","title":"Washington","url":"washington","ranking":7}},{"node":{"id":"WV","title":"West Virginia","url":"west-virginia","ranking":46}},{"node":{"id":"WI","title":"Wisconsin","url":"wisconsin","ranking":8}},{"node":{"id":"WY","title":"Wyoming","url":"wyoming","ranking":33}}]},"allSocialJson":{"edges":[{"node":{"page_id":"1","path":"/states-under-stress","title":"Rising death rates, high levels of obesity, and gaps in care are pressing challenges for states","share_path":""}},{"node":{"page_id":"2","path":"/the-divide-lives-on","title":"Regional differences in performance persist, as do within-state disparities","share_path":""}},{"node":{"page_id":"3","path":"/not-good-value","title":"Many states are not getting good value for their health care dollars","share_path":""}},{"node":{"page_id":"4","path":"/making-progress","title":"States made progress in areas that were the target of efforts to improve","share_path":""}},{"node":{"page_id":"5","path":"/conclusion","title":"Conclusion","share_path":""}},{"node":{"page_id":"6","path":"/highlights","title":"Scorecard Highlights","share_path":""}},{"node":{"page_id":"7","path":"/methodology","title":"Scorecard Methods","share_path":""}},{"node":{"page_id":"8","path":"/exhibit/exhibit-1","title":"Overall health system performance varies greatly among states","share_path":""}},{"node":{"page_id":"9","path":"/exhibit/exhibit-2","title":"More improvement than decline","share_path":""}},{"node":{"page_id":"10","path":"/exhibit/exhibit-3","title":"State health system performance varies across the country and within regions","share_path":""}},{"node":{"page_id":"11","path":"/exhibit/exhibit-4","title":"Deaths from suicide, alcohol, and drug overdose on the rise and differences between states widening","share_path":""}},{"node":{"page_id":"12","path":"/exhibit/exhibit-5","title":"Premature death rates from treatable medical conditions rose slightly following decade-long decline","share_path":""}},{"node":{"page_id":"13","path":"/exhibit/exhibit-6","title":"","share_path":""}},{"node":{"page_id":"14","path":"/exhibit/exhibit-7","title":"America’s health care divide","share_path":""}},{"node":{"page_id":"15","path":"/exhibit/exhibit-8","title":"Income-related disparities in health care access differ across states","share_path":""}},{"node":{"page_id":"16","path":"/exhibit/exhibit-9","title":"","share_path":""}},{"node":{"page_id":"17","path":"/exhibit/exhibit-10","title":"Cost barriers to receiving care fell as uninsured rates fell following ACA coverage expansions","share_path":""}},{"node":{"page_id":"18","path":"/exhibit/exhibit-11","title":"Nursing home care has improved, and home health patients have gained physical mobility","share_path":""}},{"node":{"page_id":"19","path":"/exhibit/exhibit-12","title":"Tobacco use continues to decline: Nevada and Oklahoma had among the largest reductions in adult smoking between 2011 and 2016","share_path":""}},{"node":{"page_id":"20","path":"/exhibit/exhibit-13","title":"National gains if all states achieved top rates* of performance","share_path":""}},{"node":{"page_id":"AL","path":"/state/alabama","title":"Alabama","share_path":""}},{"node":{"page_id":"AK","path":"/state/alaska","title":"Alaska","share_path":""}},{"node":{"page_id":"AZ","path":"/state/arizona","title":"Arizona","share_path":""}},{"node":{"page_id":"AR","path":"/state/arkansas","title":"Arkansas","share_path":""}},{"node":{"page_id":"CA","path":"/state/california","title":"California","share_path":""}},{"node":{"page_id":"CO","path":"/state/colorado","title":"Colorado","share_path":""}},{"node":{"page_id":"CT","path":"/state/connecticut","title":"Connecticut","share_path":""}},{"node":{"page_id":"DE","path":"/state/delaware","title":"Delaware","share_path":""}},{"node":{"page_id":"DC","path":"/state/district_of_columbia","title":"District of Columbia","share_path":""}},{"node":{"page_id":"FL","path":"/state/florida","title":"Florida","share_path":""}},{"node":{"page_id":"GA","path":"/state/georgia","title":"Georgia","share_path":""}},{"node":{"page_id":"HI","path":"/state/hawaii","title":"Hawaii","share_path":""}},{"node":{"page_id":"page_id","path":"/state/idaho","title":"Idaho","share_path":""}},{"node":{"page_id":"IL","path":"/state/illinois","title":"Illinois","share_path":""}},{"node":{"page_id":"IN","path":"/state/indiana","title":"Indiana","share_path":""}},{"node":{"page_id":"IA","path":"/state/iowa","title":"Iowa","share_path":""}},{"node":{"page_id":"KS","path":"/state/kansas","title":"Kansas","share_path":""}},{"node":{"page_id":"KY","path":"/state/kentucky","title":"Kentucky","share_path":""}},{"node":{"page_id":"LA","path":"/state/louisiana","title":"Louisiana","share_path":""}},{"node":{"page_id":"ME","path":"/state/maine","title":"Maine","share_path":""}},{"node":{"page_id":"MD","path":"/state/maryland","title":"Maryland","share_path":""}},{"node":{"page_id":"MA","path":"/state/massachusetts","title":"Massachusetts","share_path":""}},{"node":{"page_id":"MI","path":"/state/michigan","title":"Michigan","share_path":""}},{"node":{"page_id":"MN","path":"/state/minnesota","title":"Minnesota","share_path":""}},{"node":{"page_id":"MS","path":"/state/mississippi","title":"Mississippi","share_path":""}},{"node":{"page_id":"MO","path":"/state/missouri","title":"Missouri","share_path":""}},{"node":{"page_id":"MT","path":"/state/montana","title":"Montana","share_path":""}},{"node":{"page_id":"NE","path":"/state/nebraska","title":"Nebraska","share_path":""}},{"node":{"page_id":"NV","path":"/state/nevada","title":"Nevada","share_path":""}},{"node":{"page_id":"NH","path":"/state/new-hampshire","title":"New Hampshire","share_path":""}},{"node":{"page_id":"NJ","path":"/state/new-jersey","title":"New Jersey","share_path":""}},{"node":{"page_id":"NM","path":"/state/new-mexico","title":"New Mexico","share_path":""}},{"node":{"page_id":"NY","path":"/state/new-york","title":"New York","share_path":""}},{"node":{"page_id":"NC","path":"/state/north-carolina","title":"North Carolina","share_path":""}},{"node":{"page_id":"ND","path":"/state/north-dakota","title":"North Dakota","share_path":""}},{"node":{"page_id":"OH","path":"/state/ohio","title":"Ohio","share_path":""}},{"node":{"page_id":"OK","path":"/state/oklahoma","title":"Oklahoma","share_path":""}},{"node":{"page_id":"OR","path":"/state/oregon","title":"Oregon","share_path":""}},{"node":{"page_id":"PA","path":"/state/pennsylvania","title":"Pennsylvania","share_path":""}},{"node":{"page_id":"RI","path":"/state/rhode-island","title":"Rhode Island","share_path":""}},{"node":{"page_id":"SC","path":"/state/south-carolina","title":"South Carolina","share_path":""}},{"node":{"page_id":"SD","path":"/state/south-dakota","title":"South Dakota","share_path":""}},{"node":{"page_id":"TN","path":"/state/tennessee","title":"Tennessee","share_path":""}},{"node":{"page_id":"TX","path":"/state/texas","title":"Texas","share_path":""}},{"node":{"page_id":"UT","path":"/state/utah","title":"Utah","share_path":""}},{"node":{"page_id":"VT","path":"/state/vermont","title":"Vermont","share_path":""}},{"node":{"page_id":"VA","path":"/state/virginia","title":"Virginia","share_path":""}},{"node":{"page_id":"WA","path":"/state/washington","title":"Washington","share_path":""}},{"node":{"page_id":"WV","path":"/state/west-virginia","title":"West Virginia","share_path":""}},{"node":{"page_id":"WI","path":"/state/wisconsin","title":"Wisconsin","share_path":""}},{"node":{"page_id":"WY","path":"/state/wyoming","title":"Wyoming","share_path":""}}]}},"layoutContext":{}}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(558);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(238);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(385));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
	var index = memoize(RegExp.prototype.test.bind(reactPropsRegex));
	
	module.exports = index;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var PropTypes = _interopDefault(__webpack_require__(4));
	var isPropValid = _interopDefault(__webpack_require__(526));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var channel = '__EMOTION_THEMING__';
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	var testPickPropsOnStringTag = isPropValid;
	var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	var pickAssign = function pickAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	
	    var _key = void 0;
	
	    for (_key in source) {
	      if (testFn(_key)) {
	        target[_key] = source[_key];
	      }
	    }
	  }
	
	  return target;
	};
	
	function _componentWillMount() {
	  if (this.context[channel] !== undefined) {
	    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	  }
	}
	
	function _componentWillUnmount() {
	  if (this.unsubscribe !== undefined) {
	    this.context[channel].unsubscribe(this.unsubscribe);
	  }
	}
	
	function _get(target, property) {
	  switch (property) {
	    // react-hot-loader tries to access this stuff
	    case '__proto__':
	    case 'name':
	    case 'prototype':
	    case 'displayName':
	      {
	        return target[property];
	      }
	
	    default:
	      {
	        throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
	      }
	  }
	}
	
	function createEmotionStyled(emotion, view) {
	  var _createStyled = function createStyled(tag, options) {
	    if (false) {
	      if (tag === undefined) {
	        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	      }
	    }
	
	    var staticClassName;
	    var identifierName;
	    var stableClassName;
	    var shouldForwardProp;
	
	    if (options !== undefined) {
	      staticClassName = options.e;
	      identifierName = options.label;
	      stableClassName = options.target;
	      shouldForwardProp = options.shouldForwardProp;
	    }
	
	    var isReal = tag.__emotion_real === tag;
	    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	
	    if (typeof shouldForwardProp !== 'function') {
	      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
	    }
	
	    function _value() {
	      if (false) {
	        return 'NO_COMPONENT_SELECTOR';
	      } // $FlowFixMe
	
	
	      return "." + stableClassName;
	    }
	
	    return function () {
	      var args = arguments;
	      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	      if (identifierName !== undefined) {
	        styles.push("label:" + identifierName + ";");
	      }
	
	      if (staticClassName === undefined) {
	        if (args[0] == null || args[0].raw === undefined) {
	          styles.push.apply(styles, args);
	        } else {
	          styles.push(args[0][0]);
	          var len = args.length;
	          var i = 1;
	
	          for (; i < len; i++) {
	            styles.push(args[i], args[0][i]);
	          }
	        }
	      }
	
	      function _render() {
	        var props = this.props,
	            state = this.state;
	        this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
	          theme: state !== null && state.theme || props.theme || {}
	        });
	        var className = '';
	        var classInterpolations = [];
	
	        if (props.className) {
	          if (staticClassName === undefined) {
	            className += emotion.getRegisteredStyles(classInterpolations, props.className);
	          } else {
	            className += props.className + " ";
	          }
	        }
	
	        if (staticClassName === undefined) {
	          className += emotion.css.apply(this, styles.concat(classInterpolations));
	        } else {
	          className += staticClassName;
	        }
	
	        if (stableClassName !== undefined) {
	          className += " " + stableClassName;
	        }
	
	        return view.createElement(baseTag, // $FlowFixMe
	        pickAssign(shouldForwardProp, {}, props, {
	          className: className,
	          ref: props.innerRef
	        }));
	      }
	
	      var Styled =
	      /*#__PURE__*/
	      function (_view$Component) {
	        _inheritsLoose(Styled, _view$Component);
	
	        function Styled() {
	          return _view$Component.apply(this, arguments) || this;
	        }
	
	        var _proto = Styled.prototype;
	        _proto.componentWillMount = _componentWillMount;
	        _proto.componentWillUnmount = _componentWillUnmount;
	        _proto.render = _render;
	        return Styled;
	      }(view.Component);
	
	      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	      Styled.contextTypes = contextTypes;
	      Styled.__emotion_styles = styles;
	      Styled.__emotion_base = baseTag;
	      Styled.__emotion_real = Styled;
	      Object.defineProperty(Styled, 'toString', {
	        enumerable: false,
	        value: _value
	      });
	
	      Styled.withComponent = function (nextTag, nextOptions) {
	        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
	        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
	      };
	
	      return Styled;
	    };
	  };
	
	  if (false) {
	    _createStyled = new Proxy(_createStyled, {
	      get: _get
	    });
	  }
	
	  return _createStyled;
	}
	
	module.exports = createEmotionStyled;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(117);
	var isArguments = __webpack_require__(116);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(165)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collapse = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(1235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPRING_PRECISION = 1;
	
	var WAITING = 'WAITING';
	var RESIZING = 'RESIZING';
	var RESTING = 'RESTING';
	var IDLING = 'IDLING';
	
	var noop = function noop() {
	  return null;
	};
	var css = {
	  collapse: 'ReactCollapse--collapse',
	  content: 'ReactCollapse--content'
	};
	
	var Collapse = exports.Collapse = function (_React$PureComponent) {
	  _inherits(Collapse, _React$PureComponent);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      currentState: IDLING,
	      from: 0,
	      to: 0
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          forceInitialAnimation = _props.forceInitialAnimation,
	          onRest = _props.onRest;
	
	      if (isOpened) {
	        var to = this.getTo();
	        if (forceInitialAnimation) {
	          var from = this.wrapper.clientHeight;
	          this.setState({ currentState: RESIZING, from: from, to: to });
	        } else {
	          this.setState({ currentState: IDLING, from: to, to: to });
	        }
	      }
	      onRest();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasNestedCollapse) {
	        // For nested collapses we do not need to change to waiting state
	        // and should keep `height:auto`
	        // Because children will be animated and height will not jump anyway
	        // See https://github.com/nkbt/react-collapse/issues/76 for more details
	        if (nextProps.isOpened !== this.props.isOpened) {
	          // Still go to WAITING state if own isOpened was changed
	          this.setState({ currentState: WAITING });
	        }
	      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
	        this.setState({ currentState: WAITING });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      var _props2 = this.props,
	          isOpened = _props2.isOpened,
	          onRest = _props2.onRest,
	          onMeasure = _props2.onMeasure;
	
	
	      if (this.state.currentState === IDLING) {
	        onRest();
	        return;
	      }
	
	      if (prevState.to !== this.state.to) {
	        onMeasure({ height: this.state.to, width: this.content.clientWidth });
	      }
	
	      var from = this.wrapper.clientHeight;
	      var to = isOpened ? this.getTo() : 0;
	
	      if (from !== to) {
	        this.setState({ currentState: RESIZING, from: from, to: to });
	        return;
	      }
	
	      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
	        this.setState({ currentState: IDLING, from: from, to: to });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      cancelAnimationFrame(this.raf);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
	        onRest: this.onRest,
	        children: this.renderContent }));
	    }
	  }]);
	
	  return Collapse;
	}(_react2.default.PureComponent);
	
	Collapse.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
	  forceInitialAnimation: _propTypes2.default.bool,
	
	  hasNestedCollapse: _propTypes2.default.bool,
	
	  fixedHeight: _propTypes2.default.number,
	
	  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
	  style: _propTypes2.default.object,
	
	  onRender: _propTypes2.default.func,
	  onRest: _propTypes2.default.func,
	  onMeasure: _propTypes2.default.func,
	
	  children: _propTypes2.default.node.isRequired
	};
	Collapse.defaultProps = {
	  forceInitialAnimation: false,
	  hasNestedCollapse: false,
	  fixedHeight: -1,
	  style: {},
	  theme: css,
	  onRender: noop,
	  onRest: noop,
	  onMeasure: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onContentRef = function (content) {
	    _this2.content = content;
	  };
	
	  this.onWrapperRef = function (wrapper) {
	    _this2.wrapper = wrapper;
	  };
	
	  this.onRest = function () {
	    _this2.raf = requestAnimationFrame(_this2.setResting);
	  };
	
	  this.setResting = function () {
	    _this2.setState({ currentState: RESTING });
	  };
	
	  this.getTo = function () {
	    var fixedHeight = _this2.props.fixedHeight;
	
	    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
	  };
	
	  this.getWrapperStyle = function (height) {
	    if (_this2.state.currentState === IDLING && _this2.state.to) {
	      var fixedHeight = _this2.props.fixedHeight;
	
	      if (fixedHeight > -1) {
	        return { overflow: 'hidden', height: fixedHeight };
	      }
	      return { height: 'auto' };
	    }
	
	    if (_this2.state.currentState === WAITING && !_this2.state.to) {
	      return { overflow: 'hidden', height: 0 };
	    }
	
	    return { overflow: 'hidden', height: Math.max(0, height) };
	  };
	
	  this.getMotionProps = function () {
	    var springConfig = _this2.props.springConfig;
	
	
	    return _this2.state.currentState === IDLING ? {
	      // When completely stable, instantly jump to the position
	      defaultStyle: { height: _this2.state.to },
	      style: { height: _this2.state.to }
	    } : {
	      // Otherwise, animate
	      defaultStyle: { height: _this2.state.from },
	      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
	    };
	  };
	
	  this.renderContent = function (_ref) {
	    var height = _ref.height;
	
	    // eslint-disable-line
	    var _props3 = _this2.props,
	        _isOpened = _props3.isOpened,
	        _springConfig = _props3.springConfig,
	        _forceInitialAnimation = _props3.forceInitialAnimation,
	        _hasNestedCollapse = _props3.hasNestedCollapse,
	        _fixedHeight = _props3.fixedHeight,
	        theme = _props3.theme,
	        style = _props3.style,
	        onRender = _props3.onRender,
	        _onRest = _props3.onRest,
	        _onMeasure = _props3.onMeasure,
	        children = _props3.children,
	        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);
	
	    var _state = _this2.state,
	        from = _state.from,
	        to = _state.to;
	
	    // DANGEROUS, use with caution, never do setState with it
	
	    onRender({ current: height, from: from, to: to });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        ref: _this2.onWrapperRef,
	        className: theme.collapse,
	        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
	      }, props),
	      _react2.default.createElement(
	        'div',
	        { ref: _this2.onContentRef, className: theme.content },
	        children
	      )
	    );
	  };
	};

/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UnmountClosed = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
	  _inherits(UnmountClosed, _React$PureComponent);
	
	  function UnmountClosed(props) {
	    _classCallCheck(this, UnmountClosed);
	
	    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));
	
	    _this.componentWillReceiveProps = function (_ref) {
	      var isOpened = _ref.isOpened;
	
	      if (!_this.props.isOpened && isOpened) {
	        _this.setState({
	          forceInitialAnimation: true,
	          shouldUnmount: false
	        });
	      }
	    };
	
	    _this.onRest = function () {
	      var _this$props = _this.props,
	          isOpened = _this$props.isOpened,
	          onRest = _this$props.onRest;
	
	
	      if (!isOpened) {
	        _this.setState({ shouldUnmount: true });
	      }
	      if (onRest) {
	        onRest.apply(undefined, arguments);
	      }
	    };
	
	    _this.state = {
	      shouldUnmount: !_this.props.isOpened,
	      forceInitialAnimation: !_this.props.isOpened
	    };
	    return _this;
	  }
	
	  _createClass(UnmountClosed, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          _onRest = _props.onRest,
	          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);
	
	      var _state = this.state,
	          forceInitialAnimation = _state.forceInitialAnimation,
	          shouldUnmount = _state.shouldUnmount;
	
	
	      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
	        forceInitialAnimation: forceInitialAnimation,
	        isOpened: isOpened,
	        onRest: this.onRest
	      }, props));
	    }
	  }]);
	
	  return UnmountClosed;
	}(_react2.default.PureComponent);
	
	UnmountClosed.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  onRest: _propTypes2.default.func
	};

/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(485),
	    Collapse = _require.Collapse;
	
	var _require2 = __webpack_require__(1165),
	    UnmountClosed = _require2.UnmountClosed;
	
	UnmountClosed.Collapse = Collapse;
	UnmountClosed.UnmountClosed = UnmountClosed;
	
	module.exports = UnmountClosed;

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(2));
	var emotion = __webpack_require__(454);
	var createEmotionStyled = _interopDefault(__webpack_require__(826));
	
	var index = createEmotionStyled(emotion, React);
	
	exports['default'] = index;
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(129);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(115);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(127);
	
	var _HelmetConstants = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(13);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(374);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(172);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(376);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(165);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(356);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(375);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(374);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(172);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(376);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(165);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(356);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(375);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(374);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(172);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(376);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1234);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(165);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(356);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(375);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(1231);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(1232);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(1233);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(1237);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(507);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(172);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(1236);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 1236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(507);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(118);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(131);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M8 5.414L9.414 4l11.742 11.742L9.38 26.447l-1.346-1.48 10.224-9.294z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 30 30"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTggNS40MTQyMTM1NiAxLjQxNDIxMzU2LTEuNDE0MjEzNTYgMTEuNzQxNTc5NzQgMTEuNzQxNTc5OC0xMS43NzYwMTM3MiAxMC43MDU0NjcxLTEuMzQ1MzQ1NTktMS40Nzk4ODAyIDEwLjIyMzk4NjIxLTkuMjk0NTMyOXoiIC8+PC9zdmc+";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M7.222 5.808l16.97 16.97-1.414 1.414-16.97-16.97z"
	}), _react2.default.createElement("path", {
	  d: "M5.808 22.778l16.97-16.97 1.414 1.414-16.97 16.97z"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    height: 30,
	    width: 30
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwIiB2aWV3Qm94PSIwIDAgMzAgMzAiIHdpZHRoPSIzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0zIDE0aDI0djJoLTI0eiIgdHJhbnNmb3JtPSJtYXRyaXgoLjcwNzEwNjc4IC43MDcxMDY3OCAtLjcwNzEwNjc4IC43MDcxMDY3OCAxNSAtNi4yMTMyMDMpIi8+PHBhdGggZD0ibTMgMTRoMjR2MmgtMjR6IiB0cmFuc2Zvcm09Im1hdHJpeCguNzA3MTA2NzggLS43MDcxMDY3OCAuNzA3MTA2NzggLjcwNzEwNjc4IC02LjIxMzIwMyAxNSkiLz48L2c+PC9zdmc+";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M29.973 15.254a.662.662 0 0 1-.601.381h-3.12V29.37c0 .352-.279.63-.63.63H19.38a.625.625 0 0 1-.63-.63V18.754h-7.5V29.37c0 .352-.279.63-.63.63H4.379a.625.625 0 0 1-.63-.63V15.635H.629a.662.662 0 0 1-.602-.38c-.058-.25-.029-.498.147-.703L14.546.187a.646.646 0 0 1 .908 0l14.372 14.365c.176.205.205.453.147.702z",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 30 30"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTI5Ljk3MjU3MjMgMTUuMjU0NDIzNGMtLjEwMjU1MTkuMjM0Mjg5Mi0uMzUxNjA2NC4zODA3Mi0uNjAwNjYxLjM4MDcyaC0zLjEyMDUwNjd2MTMuNzM1MjA0NGMwIC4zNTE0MzM4LS4yNzgzNTUxLjYyOTY1MjItLjYyOTk2MTUuNjI5NjUyMmgtNi4yNDEwMTM0Yy0uMzUxNjA2NCAwLS42Mjk5NjE1LS4yNzgyMTg0LS42Mjk5NjE1LS42Mjk2NTIydi0xMC42MTYyMjk0aC03LjUwMDkzNjR2MTAuNjE2MjI5NGMwIC4zNTE0MzM4LS4yNzgzNTUxLjYyOTY1MjItLjYyOTk2MTUuNjI5NjUyMmgtNi4yNDEwMTM0NGMtLjM1MTYwNjM5IDAtLjYyOTk2MTQ2LS4yNzgyMTg0LS42Mjk5NjE0Ni0uNjI5NjUyMnYtMTMuNzM1MjA0NGgtMy4xMjA1MDY3NGMtLjI0OTA1NDUzIDAtLjQ5ODEwOTA2LS4xNDY0MzA4LS42MDA2NjA5Mi0uMzgwNzItLjA1ODYwMTA3LS4yNDg5MzIyLS4wMjkzMDA1My0uNDk3ODY0NS4xNDY1MDI2Ni0uNzAyODY3NmwxNC4zNzE5MTEzLTE0LjM2NDg1NjU5Yy4yNDkwNTQ2LS4yNDg5MzIyOC42NTkyNjItLjI0ODkzMjI4LjkwODMxNjYgMGwxNC4zNzE5MTEzIDE0LjM2NDg1NjU5Yy4xNzU4MDMyLjIwNTAwMzEuMjA1MTAzNy40NTM5MzU0LjE0NjUwMjcuNzAyODY3NnoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M3 24h24v2H3zM3 4h12v2H3zM3 14h24v2H3z"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    height: 30,
	    width: 30
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwIiB2aWV3Qm94PSIwIDAgMzAgMzAiIHdpZHRoPSIzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0zIDI0aDI0djJoLTI0eiIvPjxwYXRoIGQ9Im0zIDRoMTJ2MmgtMTJ6Ii8+PHBhdGggZD0ibTMgMTRoMjR2MmgtMjR6Ii8+PC9nPjwvc3ZnPg==";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _iconArrow = __webpack_require__(392);
	
	var _iconArrow2 = _interopRequireDefault(_iconArrow);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FooterModule = __webpack_require__(841);
	
	var _FooterModule2 = _interopRequireDefault(_FooterModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var siteYear = _ref.siteYear,
	      siteSubtitle = _ref.siteSubtitle;
	  return _react2.default.createElement(
	    'footer',
	    { className: _FooterModule2.default.footer + " l-container" },
	    _react2.default.createElement(
	      'div',
	      { className: _FooterModule2.default.footer__top },
	      _react2.default.createElement(
	        'h2',
	        { className: _FooterModule2.default.dataCenter__link },
	        _react2.default.createElement(
	          'a',
	          { href: 'http://datacenter.commonwealthfund.org' },
	          'The Commonwealth Fund ',
	          _react2.default.createElement('br', null),
	          'State Data Center'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _FooterModule2.default.subscribe },
	        _react2.default.createElement(
	          'h3',
	          { className: _FooterModule2.default.subscribe__title },
	          'Sign up to receive alerts and newsletters on the health policy topics you care about most.'
	        ),
	        _react2.default.createElement(_Button2.default, { href: 'http://www.commonwealthfund.org/account/register', className: 'button__primary__small', text: 'Sign Up' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _FooterModule2.default.footer__bottom },
	      _react2.default.createElement(
	        'p',
	        { className: _FooterModule2.default.copyright },
	        '\xA92018 The Commonwealth Fund'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _FooterModule2.default.contactLink },
	        'For more information about the report, contact ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.commonwealthfund.org/about-us/staff-contact-information/program-staff/senior-program-research-staff/radley-david' },
	          'David Radley'
	        ),
	        ' at the Commonwealth Fund.'
	      )
	    )
	  );
	};
	
	//  Styles
	
	
	//  Components
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-components-Footer----Footer-module---footer---VUGIP","footer__top":"src-components-Footer----Footer-module---footer__top---1GOfA","dataCenter__link":"src-components-Footer----Footer-module---dataCenter__link---3vZFr","subscribe":"src-components-Footer----Footer-module---subscribe---3BTNf","subscribe__title":"src-components-Footer----Footer-module---subscribe__title---2aUvZ","footer__bottom":"src-components-Footer----Footer-module---footer__bottom---3O7ma","copyright":"src-components-Footer----Footer-module---copyright---2-iNN","contactLink":"src-components-Footer----Footer-module---contactLink---2rTw8"};

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SiteConfig = __webpack_require__(174);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Navigation = __webpack_require__(543);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Share = __webpack_require__(544);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _cmwfLogo = __webpack_require__(582);
	
	var _cmwfLogo2 = _interopRequireDefault(_cmwfLogo);
	
	var _iconHome = __webpack_require__(579);
	
	var _iconHome2 = _interopRequireDefault(_iconHome);
	
	var _HeaderModule = __webpack_require__(842);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var siteYear = _ref.siteYear,
	      siteSubtitle = _ref.siteSubtitle,
	      isHome = _ref.isHome,
	      themes = _ref.themes,
	      states = _ref.states,
	      location = _ref.location,
	      social = _ref.social,
	      site = _ref.site;
	  return _react2.default.createElement(
	    'header',
	    { className: _HeaderModule2.default.header + " l-container" },
	    _react2.default.createElement(
	      'div',
	      { className: _HeaderModule2.default.header_title_wrap },
	      _react2.default.createElement(
	        'div',
	        { className: [_HeaderModule2.default.logo, isHome ? "" : _HeaderModule2.default.header_title_shown].join(" ") },
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.commonwealthfund.org' },
	          _react2.default.createElement(_cmwfLogo.ReactComponent, null)
	        )
	      ),
	      isHome ? "" : _react2.default.createElement(
	        'h1',
	        { className: [_HeaderModule2.default.header_title, isHome ? _HeaderModule2.default.header_title_hidden : ""].join(" ") },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/',
	            style: {
	              textDecoration: 'none'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _HeaderModule2.default.home },
	            _react2.default.createElement(_iconHome.ReactComponent, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _HeaderModule2.default.site__title__year },
	            _react2.default.createElement(
	              'strong',
	              { className: _HeaderModule2.default.site__year },
	              siteYear
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _HeaderModule2.default.site__title },
	              siteSubtitle
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Navigation2.default, { themes: themes, states: states }),
	    _react2.default.createElement(_Share2.default, { site: site, location: location, social: social })
	  );
	};
	
	//  Styles
	
	
	//  Components
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-Header----Header-module---header---2gV_n","embargo":"src-components-Header----Header-module---embargo---XTLbO","header_title_wrap":"src-components-Header----Header-module---header_title_wrap---V_9PI","logo":"src-components-Header----Header-module---logo---2Zf4H","header_title_shown":"src-components-Header----Header-module---header_title_shown---3FQR0","header_title":"src-components-Header----Header-module---header_title---2jj1Z","home":"src-components-Header----Header-module---home---TSduk","site__title__year":"src-components-Header----Header-module---site__title__year---28LiC","site__year":"src-components-Header----Header-module---site__year---3EUfa","header_title_hidden":"src-components-Header----Header-module---header_title_hidden---2Qmva"};

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M96.311 14.767a40.012 40.012 0 0 1 20.053-5.36c22.194 0 40.252 18.06 40.252 40.254 0 22.199-18.058 40.257-40.252 40.257a40.012 40.012 0 0 1-20.053-5.359 40.004 40.004 0 0 1-20.05 5.359c-22.198 0-40.255-18.058-40.255-40.257 0-22.194 18.057-40.253 40.255-40.253a40.004 40.004 0 0 1 20.05 5.359zm-2.994 1.907a36.906 36.906 0 0 0-17.056-4.154c-20.48 0-37.142 16.663-37.142 37.142 0 20.48 16.662 37.143 37.142 37.143 6.145 0 11.946-1.5 17.056-4.154-10.398-7.286-17.209-19.357-17.209-32.99 0-13.63 6.811-25.701 17.21-32.987zM21.894 89.146v-75.95L2.077 27.316 0 24.348 20.756 9.558h4.928v79.588z",
	  fill: "#cec9c2"
	}), _react2.default.createElement("path", {
	  d: "M173.893 34.872v-.103c1.753-.541 2.115-1.367 2.115-3.43V18.007h-1.212c-2.192 0-2.27.128-4.824 3.352h-.102l.464-4.282h14.623l.464 4.282h-.13c-2.526-3.224-2.629-3.352-4.795-3.352h-1.214v13.332c0 2.063.361 2.889 2.09 3.43v.103zm21.507 0v-.103c1.47-.515 1.78-1.341 1.78-3.404v-5.622c0-1.728-1.006-2.63-2.373-2.63-.877 0-2.114.387-2.862.798v7.454c0 2.063.31 2.889 1.779 3.404v.103h-6.706v-.103c1.445-.515 1.755-1.341 1.755-3.404V20.198c0-2.269-.257-2.836-2.063-3.507v-.103c1.675-.104 3.892-.696 5.131-1.161h.104V23.5c.878-.75 2.785-2.09 4.46-2.09 2.09 0 3.844 1.213 3.844 4.487v5.468c0 2.063.309 2.889 1.78 3.404v.103zm15.756-8.123c0-3.096-.72-4.642-2.398-4.642-1.598 0-2.708 1.985-2.862 4.977zm3.019 5.157c-.647 1.084-2.476 3.276-5.34 3.276-3.584 0-6.189-2.63-6.189-6.576 0-4.256 3.018-7.195 6.319-7.195 2.837 0 5.029 1.393 5.029 5.39v.85h-8.098c0 3.663 2.114 5.467 4.486 5.467 1.625 0 2.94-.747 3.638-1.314zm-27.698 25.681c-1.108.567-3.429 1.083-5.596 1.083-5.697 0-10.366-3.48-10.366-9.025 0-5.983 5.467-9.518 10.418-9.518 1.96 0 4.23.568 5.313 1.032v3.765h-.103c-1.444-2.913-3.508-3.92-5.519-3.92-3.637 0-6.551 3.225-6.551 8.331 0 5.235 3.07 8.485 6.937 8.485 2.115 0 4.204-1.006 5.7-4.178h.105zm12.483-5.88c0-3.327-1.136-6.189-3.48-6.189-2.35 0-3.458 2.862-3.458 6.19 0 2.939.877 6.215 3.457 6.215 2.604 0 3.48-3.276 3.48-6.215zm-10.368-.025c0-3.997 3.3-6.86 6.887-6.86 3.61 0 6.912 2.863 6.912 6.86 0 3.868-3.173 6.91-6.912 6.91a6.906 6.906 0 0 1-6.887-6.91zm30.947 6.602v-.104c1.444-.515 1.754-1.34 1.754-3.404v-5.622c0-1.727-.851-2.63-2.218-2.63-.8 0-2.27.49-3.018.877.181.567.284 1.263.284 2.037v5.338c0 2.064.31 2.889 1.753 3.404v.104h-6.603v-.104c1.444-.515 1.754-1.34 1.754-3.404v-5.622c0-1.727-.774-2.63-2.166-2.63-.928 0-2.01.387-2.786.8v7.452c0 2.064.31 2.889 1.78 3.404v.104h-6.627v-.104c1.471-.515 1.78-1.34 1.78-3.404v-5.183c0-2.27-.258-2.838-2.064-3.508v-.103c1.651-.103 3.713-.696 4.976-1.16h.103v2.14c.801-.774 2.684-2.114 4.385-2.114 1.496 0 2.76.644 3.354 2.27.8-.75 2.94-2.296 4.72-2.296 2.114 0 3.687 1.315 3.687 4.616v5.338c0 2.064.309 2.889 1.754 3.404v.104zm24.034 0v-.104c1.444-.515 1.754-1.34 1.754-3.404v-5.622c0-1.727-.85-2.63-2.218-2.63-.8 0-2.27.49-3.018.877.181.567.285 1.263.285 2.037v5.338c0 2.064.308 2.889 1.754 3.404v.104h-6.602v-.104c1.442-.515 1.753-1.34 1.753-3.404v-5.622c0-1.727-.774-2.63-2.167-2.63-.926 0-2.01.387-2.784.8v7.452c0 2.064.308 2.889 1.779 3.404v.104h-6.63v-.104c1.47-.515 1.781-1.34 1.781-3.404v-5.183c0-2.27-.257-2.838-2.063-3.508v-.103c1.651-.103 3.714-.696 4.976-1.16h.104v2.14c.8-.774 2.683-2.114 4.386-2.114 1.496 0 2.759.644 3.354 2.27.798-.75 2.938-2.296 4.717-2.296 2.115 0 3.687 1.315 3.687 4.616v5.338c0 2.064.31 2.889 1.755 3.404v.104zm17.974-6.576c0-3.328-1.135-6.19-3.48-6.19-2.348 0-3.458 2.862-3.458 6.19 0 2.939.877 6.215 3.457 6.215 2.603 0 3.48-3.276 3.48-6.215zm-10.366-.026c0-3.997 3.3-6.86 6.885-6.86 3.61 0 6.91 2.863 6.91 6.86 0 3.868-3.17 6.91-6.91 6.91a6.905 6.905 0 0 1-6.885-6.91zm23.39 6.602v-.104c1.444-.515 1.753-1.34 1.753-3.404v-5.622c0-1.727-1.083-2.63-2.476-2.63-.98 0-2.063.387-2.837.8v7.452c0 2.064.309 2.889 1.779 3.404v.104h-6.627v-.104c1.47-.515 1.78-1.34 1.78-3.404v-5.183c0-2.27-.259-2.838-2.064-3.508v-.103c1.65-.103 3.713-.696 4.978-1.16h.104v2.14c.98-.902 2.887-2.114 4.616-2.114 1.984 0 3.842 1.134 3.842 4.46v5.468c0 2.064.309 2.889 1.753 3.404v.104zm19.676 0l-2.708-8.278-2.837 8.278h-2.373l-2.655-8.252c-1.135-3.509-1.677-4.308-2.916-4.797v-.104h6.913v.104c-.93.232-1.368.567-1.368 1.573 0 .799.31 2.088.8 3.842l1.496 5.442 3.507-10.96h1.032l3.3 10.96 1.548-4.54c.67-1.96 1.085-3.455 1.085-4.435 0-1.187-.57-1.65-1.625-1.882v-.104h5.516v.104c-1.288.413-2.063 1.263-3.35 4.797l-3.045 8.252zm16.35-8.125c0-3.094-.722-4.64-2.4-4.64-1.597 0-2.708 1.985-2.86 4.977zm3.016 5.16c-.644 1.082-2.475 3.274-5.338 3.274-3.585 0-6.19-2.63-6.19-6.576 0-4.255 3.018-7.195 6.32-7.195 2.837 0 5.029 1.393 5.029 5.39v.85h-8.098c0 3.663 2.112 5.467 4.487 5.467 1.622 0 2.94-.747 3.635-1.314zm9.051-3.611a3.89 3.89 0 0 0-.774-.078c-1.624 0-3.377.93-3.377 3.017 0 1.522 1.21 2.321 2.5 2.321.465 0 1.187-.154 1.651-.439zm5.417 5.88c-.517.309-2.295.928-3.353.928-1.007 0-1.907-.542-2.038-1.676-.826.721-2.27 1.753-3.945 1.753-1.884 0-3.353-1.237-3.353-3.12 0-2.037 2.01-4.024 7.272-4.539V49.36c0-2.088-1.108-3.636-3.094-3.636-.929 0-1.832.413-2.217.697.876.18 1.545.773 1.545 1.599 0 .928-.72 1.521-1.545 1.521-.852 0-1.573-.696-1.573-1.521 0-1.702 2.914-3.198 5.57-3.198 2.681 0 4.41 1.315 4.41 4.1v6.113c0 2.088.928 2.321 2.321 2.449zm.231.696v-.104c1.47-.515 1.78-1.34 1.78-3.404V43.61c0-2.27-.26-2.837-2.064-3.508V40c1.65-.103 3.87-.696 5.133-1.161h.101v15.938c0 2.064.31 2.889 1.755 3.404v.104zm16.197-1.857c-.57.722-1.935 2.063-3.716 2.063-1.96 0-3.454-1.031-3.454-3.92v-8.098h-1.884v-.129l1.136-.619c1.675-.928 2.656-2.347 3.712-3.79h.128v3.197h3.406v1.392h-3.406v7.893c0 1.443.801 2.371 2.143 2.371.62 0 1.29-.154 1.83-.49zm8.715 1.857v-.104c1.469-.515 1.78-1.34 1.78-3.404v-5.622c0-1.727-1.006-2.63-2.375-2.63-.877 0-2.113.387-2.861.8v7.452c0 2.064.308 2.889 1.779 3.404v.104h-6.705v-.104c1.443-.515 1.753-1.34 1.753-3.404V43.61c0-2.27-.257-2.837-2.063-3.508V40c1.676-.103 3.895-.696 5.134-1.161h.102v8.073c.877-.749 2.785-2.09 4.462-2.09 2.09 0 3.84 1.213 3.84 4.487v5.468c0 2.064.31 2.889 1.781 3.404v.104zm-182.58 24.175v-.101c1.753-.542 2.115-1.368 2.115-3.431V68.174c0-2.038-.362-2.863-2.115-3.405v-.104h12.636v3.972h-.13c-1.675-2.888-1.959-3.042-4.744-3.042h-2.374v7.504h3.329c1.367 0 1.96-.361 2.835-1.728h.104v4.41h-.104c-.875-1.342-1.468-1.728-2.835-1.728h-3.329v4.874c0 2.063.492 2.889 2.503 3.43v.102zm29.167-.85c-2.244.207-3.713.696-4.978 1.162h-.103v-2.218c-.929.876-2.476 2.218-4.256 2.218-1.88 0-3.816-.904-3.816-4.204V73.77c0-2.27-.258-2.837-2.063-3.508v-.103c1.677-.104 3.792-.697 5.055-1.16h.104v9.362c0 1.702 1.313 2.423 2.656 2.423.876 0 1.47-.129 2.242-.567V73.77c0-2.27-.256-2.837-2.061-3.508v-.103c1.675-.104 3.79-.697 5.053-1.16h.104v9c0 2.27.258 2.837 2.063 3.507zm9.54.85v-.101c1.445-.517 1.754-1.342 1.754-3.404V73.33c0-1.728-1.082-2.63-2.476-2.63-.978 0-2.061.387-2.836.799v7.454c0 2.062.31 2.887 1.78 3.404v.101h-6.63v-.101c1.472-.517 1.78-1.342 1.78-3.404V73.77c0-2.27-.257-2.837-2.063-3.508v-.103c1.65-.104 3.715-.697 4.977-1.16h.105v2.14c.98-.904 2.887-2.115 4.616-2.115 1.986 0 3.843 1.135 3.843 4.462v5.468c0 2.062.309 2.887 1.753 3.404v.101zm17.229-12.093c-.388-.336-1.343-.672-2.167-.672-2.656 0-4.566 2.554-4.566 5.88 0 3.483 2.374 5.21 4.489 5.21.747 0 1.572-.181 2.244-.542zm5.234 11.244c-2.244.206-3.87.695-5.13 1.16h-.104v-2.217c-.8.979-2.297 2.218-4.282 2.218-2.68 0-5.57-2.245-5.57-6.139 0-4.874 3.972-7.633 7.762-7.633.697 0 1.444.103 2.09.231v-1.444c0-2.269-.259-2.837-2.244-3.507v-.103c1.65-.104 4.076-.696 5.31-1.16h.104V78c0 2.268.26 2.836 2.064 3.506zM154.294 49.662c0 20.95-16.984 37.933-37.93 37.933-20.947 0-37.933-16.983-37.933-37.933S95.417 11.73 116.364 11.73c20.946 0 37.93 16.983 37.93 37.932",
	  fill: "#1a466e"
	}), _react2.default.createElement("path", {
	  d: "M124.238 17.002l-4.363 11.558-.692 2.656-.478 2.697-.538 2.88-.497 3.191-.449 3.822h-.854v-3.462l-.673-.046v3.508h-.947l-.218-3.658-.276-3.356-.496-3.102-.354-2.468-.815-3.066-4.635-11.154s4.677 9.41 7.632 10.973c.264.14.937.151 1.203.01 2.94-1.54 7.45-10.983 7.45-10.983m-5.594 4.45a2.228 2.228 0 1 1-4.456 0 2.228 2.228 0 0 1 4.456 0m30.94 36.364l-11.56-4.364-2.653-.69-2.698-.478-2.877-.54-3.195-.494-3.822-.449v-.856l-.662.069v-.352l.662-.39v-.945l3.662-.22 3.355-.276 3.1-.494 2.467-.358 3.067-.812 11.153-4.635s-9.41 4.677-10.97 7.632c-.143.264-.155.936-.014 1.203 1.54 2.94 10.984 7.45 10.984 7.45m-4.447-5.593a2.23 2.23 0 0 1-2.23-2.228 2.231 2.231 0 0 1 2.23-2.227c1.23 0 2.226.998 2.226 2.227a2.225 2.225 0 0 1-2.226 2.228M83.141 41.532L94.7 45.895l2.654.69 2.697.48 2.879.537 3.194.498 3.822.448v.855h-3.462l-.047.675h3.509v.944l-3.658.22-3.358.276-3.101.494-2.468.356-3.067.814-11.152 4.634s9.41-4.675 10.971-7.632c.142-.263.152-.935.012-1.202-1.542-2.939-10.983-7.45-10.983-7.45m4.45 5.595a2.226 2.226 0 1 1 0 4.451 2.227 2.227 0 1 1 0-4.45m57.266-15.236l-11.262 5.086-2.363 1.391-2.244 1.567-2.419 1.655-2.607 1.908-3.02 2.386-.607-.607-.513.294-.63-.665.667-.103-.668-.669 2.433-2.742 2.177-2.569 1.846-2.543 1.491-2 1.596-2.742 4.607-11.163s-3.347 9.962-2.362 13.154c.088.287.555.772.842.858 3.167.991 13.036-2.496 13.036-2.496m-7.103-.81a2.223 2.223 0 0 1-3.148 0 2.228 2.228 0 0 1 3.149-3.15c.871.87.87 2.279-.001 3.15M98.929 20.22l5.086 11.257 1.39 2.366 1.569 2.247 1.653 2.417 1.909 2.607 2.386 3.021-.605.606.255.757-.313.387-.418-.669-.67.669-2.74-2.434-2.572-2.176-2.54-1.846-2.002-1.49-2.74-1.595-11.164-4.608s9.96 3.345 13.154 2.361c.287-.086.771-.553.86-.843.988-3.166-2.498-13.034-2.498-13.034m-.81 7.102a2.23 2.23 0 0 1 0 3.15 2.23 2.23 0 0 1-3.15 0 2.233 2.233 0 0 1-.003-3.152 2.232 2.232 0 0 1 3.153.002m26.119 55.001l-4.363-11.559-.692-2.654-.478-2.696-.538-2.88-.497-3.192-.449-3.824h-.854l.572-1.66-1.258.74.013.92h-.947l-.218 3.66-.276 3.356-.496 3.104-.354 2.466-.815 3.067-4.635 11.152s4.677-9.409 7.632-10.972c.264-.142.937-.153 1.203-.012 2.94 1.543 7.45 10.984 7.45 10.984m-5.594-4.45a2.225 2.225 0 0 0-2.23-2.224 2.224 2.224 0 0 0-2.223 2.224 2.227 2.227 0 1 0 4.454 0m26.212-10.437l-11.262-5.09-2.363-1.39-2.244-1.567-2.419-1.654-2.607-1.908-3.02-2.386-.607.604 2.45 2.45-.445.51-2.481-2.483-.668.67 2.433 2.742 2.177 2.57 1.846 2.542 1.491 1.996 1.596 2.746 4.607 11.161s-3.347-9.96-2.362-13.154c.088-.288.555-.77.842-.86 3.167-.986 13.036 2.501 13.036 2.501m-7.103.808a2.223 2.223 0 0 0-3.148 0 2.229 2.229 0 0 0 0 3.15 2.226 2.226 0 1 0 3.147-3.15M98.93 79.107l5.086-11.26 1.39-2.365 1.569-2.245 1.653-2.417 1.909-2.61 2.386-3.018-.605-.604-2.45 2.448-.51-.446 2.484-2.482-.67-.667-2.74 2.433-2.572 2.179-2.54 1.842-2.002 1.494-2.74 1.593-11.164 4.61s9.96-3.348 13.154-2.366c.287.09.771.556.86.845.988 3.17-2.498 13.036-2.498 13.036m-.81-7.104a2.226 2.226 0 1 0-3.15-3.147c-.87.87-.87 2.282-.003 3.15a2.23 2.23 0 0 0 3.153-.003",
	  fill: "#b7ded8"
	}), _react2.default.createElement("path", {
	  d: "M22 109.32h3.914l-1.998-5.254zm-3.832 5.706l5.294-13.74h1.01l5.397 13.74h-1.792l-1.628-4.244h-4.984l-1.567 4.244zm26.554-2.493a6.9 6.9 0 0 1-.66.989c-.26.33-.57.625-.927.886-.357.26-.769.473-1.235.639a4.769 4.769 0 0 1-1.587.247c-.81 0-1.562-.135-2.256-.403a4.684 4.684 0 0 1-1.812-1.255c-.515-.57-.92-1.302-1.216-2.195-.296-.892-.442-1.97-.442-3.233 0-1.278.157-2.372.473-3.286.316-.913.731-1.658 1.247-2.236.515-.576 1.099-.999 1.75-1.266a5.18 5.18 0 0 1 1.988-.402c1.044 0 1.97.255 2.782.762a4.712 4.712 0 0 1 1.812 2.06l-1.339.804a4.496 4.496 0 0 0-.484-.752 3.684 3.684 0 0 0-.7-.68 4.032 4.032 0 0 0-.886-.495 2.752 2.752 0 0 0-1.04-.195c-1.21 0-2.153.494-2.832 1.484-.68.989-1.02 2.395-1.02 4.221 0 .894.103 1.687.308 2.38.207.694.488 1.277.845 1.75.357.475.78.833 1.267 1.072a3.51 3.51 0 0 0 1.575.361c.4 0 .752-.054 1.062-.165a3.309 3.309 0 0 0 1.524-1.102c.2-.253.381-.518.546-.793zm8.24-3.77a2.846 2.846 0 0 0-.248-1.122c-.151-.323-.343-.59-.577-.803s-.501-.37-.803-.475a2.808 2.808 0 0 0-.906-.154c-.66 0-1.227.195-1.7.587-.474.391-.8 1.048-.978 1.968zm-5.357 1.257c0 1.236.282 2.204.845 2.905.563.7 1.38 1.05 2.451 1.05.618 0 1.14-.15 1.566-.453.425-.302.77-.673 1.03-1.113l1.05.7a4.823 4.823 0 0 1-1.39 1.536c-.57.404-1.336.607-2.297.607-.742 0-1.408-.113-1.998-.339a4.153 4.153 0 0 1-1.514-.989c-.42-.433-.742-.972-.969-1.617-.226-.646-.34-1.393-.34-2.246 0-.782.107-1.487.32-2.111.212-.625.507-1.161.885-1.608a3.828 3.828 0 0 1 1.381-1.03 4.408 4.408 0 0 1 1.803-.36c.727 0 1.362.124 1.905.37.542.248.992.595 1.35 1.041.356.448.623.983.802 1.608.179.625.269 1.308.269 2.05zm9.167 5.006V105.2h1.463l.103.782a5.2 5.2 0 0 1 1.411-.742 5.06 5.06 0 0 1 1.7-.287c1.345 0 2.296.333 2.852.998.556.667.835 1.652.835 2.957v6.118h-1.587v-6.16c0-.823-.186-1.47-.556-1.936-.37-.466-.975-.7-1.812-.7-.523 0-1.034.112-1.535.34a6.47 6.47 0 0 0-1.288.751v7.705zm13.163-2.246c0 .481.093.8.278.958.186.158.423.236.711.236.261 0 .508-.053.742-.164.233-.11.445-.24.638-.391l.618 1.072c-.316.234-.628.419-.937.556s-.745.205-1.308.205c-.742 0-1.312-.19-1.71-.566-.399-.378-.597-.958-.597-1.74v-6.448h-1.69V105.2h1.69v-2.678h1.585v2.678h2.576v1.298h-2.596zm5.85-1.277c0 .866.2 1.494.598 1.885.398.391.988.586 1.771.586.508 0 1.013-.105 1.515-.318.5-.214.909-.47 1.225-.773V105.2h1.607v9.826H81.04l-.104-.763a5.172 5.172 0 0 1-1.297.72c-.467.18-1.05.27-1.751.27-1.291 0-2.229-.316-2.812-.948-.584-.632-.875-1.594-.875-2.884V105.2h1.586zm9.353 3.523V105.2h1.442l.124.865c.26-.275.597-.529 1.009-.762.412-.233.83-.35 1.257-.35a5.244 5.244 0 0 1 1.42.185l-.287 1.462c-.344-.15-.777-.226-1.298-.226-.399 0-.78.11-1.143.329-.365.22-.677.447-.938.68v7.643zm5.664 2.595c.151.055.34.107.567.155.226.047.456.073.69.073.316 0 .563-.077.742-.228.178-.15.363-.446.556-.885l.803-1.957-3.872-9.58H92.1l2.905 7.56 2.904-7.56h1.71l-5.026 12.422c-.247.605-.594 1.017-1.04 1.236-.447.22-.91.33-1.391.33a4.02 4.02 0 0 1-1-.135c-.35-.089-.62-.175-.813-.256zm15.78-4.861c.26.357.58.648.958.876.378.226.813.338 1.308.338.508 0 .95-.112 1.329-.338.377-.228.693-.522.947-.886s.443-.78.567-1.247a5.527 5.527 0 0 0 0-2.843 3.907 3.907 0 0 0-.567-1.246 2.959 2.959 0 0 0-.947-.875c-.379-.22-.821-.33-1.33-.33-.507 0-.95.11-1.328.33-.378.22-.69.511-.937.875a4.077 4.077 0 0 0-.557 1.236c-.123.46-.185.931-.185 1.41 0 .496.062.976.185 1.443.125.466.31.887.557 1.257zm.268 2.06a4.473 4.473 0 0 1-1.422-1.184 5.09 5.09 0 0 1-.866-1.67 6.465 6.465 0 0 1-.287-1.905c0-.645.092-1.274.277-1.884.186-.612.47-1.157.856-1.638a4.277 4.277 0 0 1 1.431-1.154c.57-.288 1.24-.432 2.009-.432.755 0 1.421.148 1.998.442a4.286 4.286 0 0 1 1.432 1.164c.378.481.662 1.03.855 1.649a6.353 6.353 0 0 1 0 3.79 5.114 5.114 0 0 1-.855 1.648c-.378.48-.855.868-1.432 1.163-.577.296-1.243.443-1.998.443-.755 0-1.422-.144-1.998-.432zm9.166.206v-8.528h-1.442V105.2h1.463v-.722c0-.631.072-1.166.216-1.606.144-.439.347-.796.608-1.071.26-.275.57-.474.927-.597a3.628 3.628 0 0 1 1.195-.186c.522 0 .964.052 1.328.155.364.103.683.23.958.38l-.474 1.216a6.242 6.242 0 0 0-.772-.299 3.172 3.172 0 0 0-.958-.134c-.234 0-.44.028-.618.082a.905.905 0 0 0-.454.32c-.122.158-.218.378-.288.66-.068.28-.103.648-.103 1.101v.7h2.349v1.299h-2.329v8.528zm11.722-5.706h3.913l-1.997-5.254zm-3.832 5.706l5.294-13.74h1.01l5.396 13.74h-1.791l-1.628-4.244h-4.985l-1.565 4.244zm19.344-8.323a1.772 1.772 0 0 0-.34-.164 5.073 5.073 0 0 0-1.04-.268 3.897 3.897 0 0 0-.557-.042c-.577 0-1.078.11-1.503.33-.427.22-.78.512-1.062.876-.28.364-.49.78-.628 1.245a5.029 5.029 0 0 0-.206 1.423c0 .55.062 1.06.186 1.535.123.473.312.881.566 1.225.254.344.57.614.948.814.377.198.827.297 1.349.297.412 0 .816-.084 1.215-.256.398-.172.755-.457 1.072-.855zm.123 8.323l-.123-.803c-.358.37-.746.635-1.164.793-.42.157-.876.236-1.37.236-.701 0-1.322-.133-1.865-.401-.542-.268-.999-.636-1.37-1.102a4.895 4.895 0 0 1-.844-1.659 7.138 7.138 0 0 1-.289-2.07c0-.631.1-1.253.299-1.865.2-.61.494-1.153.886-1.626a4.355 4.355 0 0 1 1.472-1.144c.59-.288 1.278-.432 2.06-.432.495 0 .92.038 1.278.112.357.076.66.162.907.258v-4.038h1.585v13.74zm6.303 0l-3.688-9.826h1.711l2.925 8.013 2.945-8.013h1.607l-3.687 9.826zm11.928-5.13a18.3 18.3 0 0 0-1.442.104c-.508.054-.979.16-1.411.319-.433.158-.79.388-1.072.69-.282.302-.422.7-.422 1.195 0 .315.062.583.186.803.123.22.277.401.462.546.186.144.392.247.62.309.226.062.449.092.668.092.481 0 .924-.099 1.33-.298a4.992 4.992 0 0 0 1.08-.71zm.144 5.13l-.082-.845a3.645 3.645 0 0 1-1.185.794 3.825 3.825 0 0 1-1.473.277c-.425 0-.841-.065-1.246-.196a3.188 3.188 0 0 1-1.071-.576 2.879 2.879 0 0 1-.752-.958c-.193-.384-.289-.831-.289-1.34 0-.7.189-1.276.567-1.73a4.046 4.046 0 0 1 1.432-1.08 7.149 7.149 0 0 1 1.916-.567c.7-.11 1.38-.165 2.039-.165v-.124c0-.824-.175-1.414-.526-1.771-.35-.357-.854-.536-1.513-.536-.453 0-.869.1-1.247.298-.378.2-.697.463-.958.794l-1.112-.783c.398-.536.868-.93 1.411-1.184s1.225-.381 2.05-.381c1.098 0 1.953.281 2.564.844.611.564.917 1.504.917 2.822v6.407zm4.017 0V105.2h1.463l.102.782a5.2 5.2 0 0 1 1.412-.742 5.064 5.064 0 0 1 1.7-.287c1.344 0 2.296.333 2.852.998.556.667.835 1.652.835 2.957v6.118h-1.586v-6.16c0-.823-.186-1.47-.556-1.936-.372-.466-.976-.7-1.814-.7-.522 0-1.034.112-1.535.34-.501.226-.93.477-1.287.751v7.705zm18.746-2.101c-.385.797-.91 1.383-1.576 1.761a4.226 4.226 0 0 1-2.112.566 4.86 4.86 0 0 1-1.7-.309 4.042 4.042 0 0 1-1.472-.947c-.426-.425-.77-.959-1.03-1.597-.261-.638-.392-1.39-.392-2.255 0-.92.13-1.71.391-2.37.261-.659.605-1.198 1.03-1.617a3.955 3.955 0 0 1 1.442-.917 4.743 4.743 0 0 1 1.608-.287c.548 0 1.033.081 1.452.247a3.791 3.791 0 0 1 1.792 1.4c.185.275.319.523.402.742l-1.174.741c-.289-.66-.653-1.132-1.092-1.42a2.48 2.48 0 0 0-1.38-.434c-.371 0-.729.086-1.072.258a2.917 2.917 0 0 0-.927.752 3.8 3.8 0 0 0-.66 1.216c-.163.48-.246 1.029-.246 1.648 0 .618.083 1.166.247 1.648.165.48.388.885.67 1.214a2.825 2.825 0 0 0 2.193 1.01c.481 0 .945-.137 1.391-.412.446-.274.814-.72 1.102-1.339zm1.75 2.1h1.607V105.2h-1.607zm.804-11.391a.965.965 0 0 1-.741-.34 1.195 1.195 0 0 1-.31-.834c0-.316.103-.59.31-.824a.956.956 0 0 1 1.483 0c.206.234.308.508.308.824 0 .328-.102.608-.309.834a.967.967 0 0 1-.741.34zm3.44 11.392V105.2h1.462l.104.782c.398-.302.868-.55 1.41-.742a5.064 5.064 0 0 1 1.7-.287c1.346 0 2.298.333 2.853.998.556.667.835 1.652.835 2.957v6.118h-1.586v-6.16c0-.823-.186-1.47-.556-1.936-.371-.466-.976-.7-1.814-.7-.521 0-1.034.112-1.535.34-.501.226-.93.477-1.287.751v7.705zm12.38-5.85c.124.26.299.494.526.7.226.206.497.37.813.494a2.92 2.92 0 0 0 1.071.186c.33 0 .657-.039.98-.113.322-.076.617-.2.885-.371.267-.171.484-.402.648-.69.165-.289.248-.638.248-1.051 0-.343-.076-.649-.227-.917a1.99 1.99 0 0 0-.597-.66 2.808 2.808 0 0 0-.855-.39 3.696 3.696 0 0 0-1.977 0c-.324.09-.608.219-.855.39a1.878 1.878 0 0 0-.824 1.598c0 .288.054.563.164.824zm2.472 5.19c-.92-.027-1.552-.068-1.895-.123-.357.179-.646.412-.865.7-.22.288-.33.66-.33 1.112 0 .317.09.592.268.824.179.235.426.43.741.589.317.156.69.277 1.123.36.433.082.91.123 1.432.123.948 0 1.72-.172 2.318-.515.597-.343.896-.804.896-1.38 0-.29-.056-.536-.165-.742-.11-.206-.306-.377-.587-.515-.282-.136-.659-.24-1.133-.308a14.943 14.943 0 0 0-1.803-.125zm3.462-8.137c.247.275.445.588.597.94.15.348.226.743.226 1.183 0 .576-.12 1.08-.36 1.514-.24.432-.56.793-.958 1.081a4.111 4.111 0 0 1-1.38.638 6.23 6.23 0 0 1-1.607.207c-.18 0-.402-.014-.67-.041a8.605 8.605 0 0 1-.628-.083c-.22.027-.426.1-.618.216-.193.118-.288.271-.288.464 0 .22.161.382.484.484.322.103.91.162 1.76.175.825.014 1.552.068 2.185.164.632.097 1.167.255 1.606.475.44.22.773.518 1 .896.226.378.34.855.34 1.431 0 .536-.124 1.003-.37 1.401-.248.398-.585.731-1.01 1-.426.267-.924.47-1.494.606a7.605 7.605 0 0 1-1.803.208c-1.579 0-2.805-.242-3.678-.722-.87-.481-1.307-1.236-1.307-2.266 0-1.058.48-1.84 1.442-2.348a1.712 1.712 0 0 1-.618-.454c-.165-.191-.247-.44-.247-.74 0-.385.148-.701.443-.95a2.722 2.722 0 0 1 1.102-.534 4.328 4.328 0 0 1-.566-.35 2.918 2.918 0 0 1-.598-.577 3.236 3.236 0 0 1-.464-.815 2.907 2.907 0 0 1-.185-1.08c0-.577.12-1.079.36-1.504.24-.426.56-.78.958-1.062.399-.28.849-.49 1.35-.628a5.815 5.815 0 0 1 1.534-.205c.412 0 .814.038 1.206.112a4.97 4.97 0 0 1 1.123.36l1.461-1.462 1.01.927zm7.292 8.797v-13.74h1.648v5.953h6.88v-5.954h1.627v13.74h-1.627v-6.324h-6.88v6.325zm19.487-6.262a2.846 2.846 0 0 0-.248-1.123 2.518 2.518 0 0 0-.576-.803 2.293 2.293 0 0 0-.804-.475 2.8 2.8 0 0 0-.906-.154c-.659 0-1.226.195-1.7.587-.474.391-.8 1.048-.978 1.968zm-5.357 1.256c0 1.236.281 2.204.845 2.905.563.7 1.38 1.05 2.45 1.05.62 0 1.141-.15 1.568-.453a3.608 3.608 0 0 0 1.03-1.113l1.049.7a4.81 4.81 0 0 1-1.39 1.536c-.57.404-1.336.607-2.296.607-.742 0-1.409-.113-1.998-.339a4.15 4.15 0 0 1-1.515-.989c-.418-.433-.741-.972-.968-1.617-.227-.646-.34-1.393-.34-2.246 0-.782.106-1.487.318-2.111.214-.625.51-1.161.887-1.608a3.822 3.822 0 0 1 1.38-1.03 4.42 4.42 0 0 1 1.803-.36c.727 0 1.362.124 1.906.37.541.248.99.595 1.348 1.041.358.448.625.983.804 1.608.179.625.268 1.308.268 2.05zm14.482-.123c-.453.013-.933.048-1.442.103-.507.054-.977.16-1.41.319a2.7 2.7 0 0 0-1.072.69c-.281.302-.422.7-.422 1.195 0 .315.06.583.186.803a1.75 1.75 0 0 0 1.08.855c.228.062.45.092.67.092.48 0 .924-.099 1.329-.298a4.972 4.972 0 0 0 1.081-.71zm.145 5.129l-.083-.845a3.624 3.624 0 0 1-1.184.794 3.819 3.819 0 0 1-1.473.277 4.01 4.01 0 0 1-1.246-.196 3.208 3.208 0 0 1-1.072-.576 2.898 2.898 0 0 1-.751-.958c-.193-.384-.289-.831-.289-1.34 0-.7.19-1.276.567-1.73a4.046 4.046 0 0 1 1.432-1.08 7.152 7.152 0 0 1 1.915-.567c.7-.11 1.38-.165 2.04-.165v-.124c0-.824-.175-1.414-.526-1.771-.35-.357-.854-.536-1.514-.536-.453 0-.87.1-1.246.298-.378.2-.697.463-.958.794l-1.113-.783c.399-.536.87-.93 1.412-1.184.542-.254 1.225-.381 2.049-.381 1.099 0 1.954.281 2.565.844.611.564.917 1.504.917 2.822v6.407zm4.016 0h1.585v-13.74h-1.585zm6.449-2.246c0 .481.092.8.277.958.185.158.422.236.71.236.26 0 .509-.053.743-.164.233-.11.446-.24.638-.391l.618 1.072a5.001 5.001 0 0 1-.938.556c-.308.137-.745.205-1.307.205-.741 0-1.313-.19-1.71-.566-.398-.378-.598-.958-.598-1.74v-6.448h-1.69V105.2h1.69v-2.678h1.587v2.678h2.574v1.298h-2.594zm4.324 2.246v-13.74h1.586v4.696a6.191 6.191 0 0 1 1.36-.732 4.658 4.658 0 0 1 1.708-.297c1.333 0 2.277.336 2.833 1.009.558.674.836 1.654.836 2.946v6.118h-1.607v-6.14c0-.906-.186-1.576-.557-2.007-.37-.433-.968-.65-1.791-.65-.524 0-1.027.122-1.514.361-.488.24-.91.491-1.268.752v7.684zm24.534-2.493a6.9 6.9 0 0 1-.66.989c-.26.33-.57.625-.927.886-.356.26-.77.473-1.235.639a4.769 4.769 0 0 1-1.587.247c-.81 0-1.563-.135-2.256-.403a4.69 4.69 0 0 1-1.812-1.255c-.515-.57-.921-1.302-1.216-2.195-.295-.892-.443-1.97-.443-3.233 0-1.278.158-2.372.474-3.286.316-.913.732-1.658 1.246-2.236.516-.576 1.099-.999 1.751-1.266a5.187 5.187 0 0 1 1.989-.402c1.044 0 1.97.255 2.78.762a4.712 4.712 0 0 1 1.813 2.06l-1.339.804a4.45 4.45 0 0 0-.484-.752 3.635 3.635 0 0 0-.701-.68 4.007 4.007 0 0 0-.885-.495 2.752 2.752 0 0 0-1.04-.195c-1.208 0-2.153.494-2.833 1.484-.68.989-1.02 2.395-1.02 4.221 0 .894.103 1.687.31 2.38.206.694.487 1.277.843 1.75.358.475.78.833 1.267 1.072.488.241 1.013.361 1.577.361.398 0 .752-.054 1.06-.165.31-.11.591-.257.845-.443.254-.185.48-.405.68-.66.2-.252.381-.517.546-.792zm7.107-2.636c-.453.013-.934.048-1.442.103-.509.054-.979.16-1.411.319-.432.158-.79.388-1.072.69-.28.302-.422.7-.422 1.195 0 .315.062.583.186.803a1.755 1.755 0 0 0 1.08.855c.228.062.45.092.67.092.482 0 .924-.099 1.33-.298a5.013 5.013 0 0 0 1.081-.71zm.144 5.129l-.083-.845a3.627 3.627 0 0 1-1.185.794 3.816 3.816 0 0 1-1.473.277c-.424 0-.84-.065-1.244-.196a3.192 3.192 0 0 1-1.073-.576 2.887 2.887 0 0 1-.75-.958c-.194-.384-.29-.831-.29-1.34 0-.7.189-1.276.567-1.73a4.05 4.05 0 0 1 1.431-1.08c.578-.268 1.216-.457 1.916-.567s1.38-.165 2.04-.165v-.124c0-.824-.175-1.414-.526-1.771-.35-.357-.853-.536-1.514-.536-.453 0-.869.1-1.245.298-.378.2-.698.463-.96.794l-1.111-.783c.398-.536.868-.93 1.411-1.184.542-.254 1.226-.381 2.05-.381 1.098 0 1.953.281 2.564.844.612.564.917 1.504.917 2.822v6.407zm4.016 0V105.2h1.441l.125.865c.26-.275.597-.529 1.009-.762.411-.233.83-.35 1.257-.35.302 0 .58.02.834.061.254.041.45.083.587.124l-.288 1.462c-.344-.15-.777-.226-1.297-.226-.4 0-.781.11-1.144.329-.365.22-.677.447-.938.68v7.643zm12.67-6.262a2.831 2.831 0 0 0-.249-1.123 2.529 2.529 0 0 0-.575-.803 2.3 2.3 0 0 0-.804-.475 2.81 2.81 0 0 0-.907-.154c-.659 0-1.226.195-1.7.587-.474.391-.8 1.048-.978 1.968zm-5.357 1.256c0 1.236.28 2.204.844 2.905.563.7 1.38 1.05 2.451 1.05.619 0 1.14-.15 1.566-.453.426-.302.77-.673 1.031-1.113l1.05.7a4.83 4.83 0 0 1-1.39 1.536c-.57.404-1.336.607-2.297.607-.743 0-1.409-.113-1.998-.339a4.156 4.156 0 0 1-1.515-.989c-.42-.433-.741-.972-.968-1.617-.227-.646-.34-1.393-.34-2.246 0-.782.107-1.487.32-2.111.211-.625.507-1.161.885-1.608a3.818 3.818 0 0 1 1.38-1.03 4.414 4.414 0 0 1 1.803-.36c.728 0 1.363.124 1.906.37.542.248.992.595 1.349 1.041.356.448.624.983.803 1.608.179.625.268 1.308.268 2.05zm13.513 5.006v-8.528h-1.442V105.2h1.463v-.722c0-.631.072-1.166.217-1.606.143-.439.346-.796.607-1.071.26-.275.57-.474.927-.597a3.632 3.632 0 0 1 1.194-.186c.523 0 .964.052 1.328.155.364.103.683.23.958.38l-.472 1.216a6.256 6.256 0 0 0-.773-.299c-.282-.089-.6-.134-.958-.134-.234 0-.44.028-.619.082a.9.9 0 0 0-.452.32c-.125.158-.22.378-.289.66-.069.28-.103.648-.103 1.101v.7h2.348v1.299h-2.327v8.528zm6.922-2.266c.26.357.58.648.958.876.378.226.813.338 1.307.338.509 0 .952-.112 1.33-.338.378-.228.693-.522.947-.886s.443-.78.566-1.247a5.491 5.491 0 0 0 0-2.843 3.888 3.888 0 0 0-.566-1.246 2.953 2.953 0 0 0-.948-.875c-.377-.22-.82-.33-1.329-.33-.507 0-.95.11-1.328.33-.378.22-.69.511-.937.875a4.055 4.055 0 0 0-.556 1.236c-.124.46-.186.931-.186 1.41 0 .496.062.976.186 1.443.124.466.309.887.556 1.257zm.267 2.06a4.476 4.476 0 0 1-1.42-1.184 5.077 5.077 0 0 1-.867-1.67 6.465 6.465 0 0 1-.009-3.79c.184-.61.47-1.156.854-1.637a4.297 4.297 0 0 1 1.432-1.154c.57-.288 1.24-.432 2.008-.432.755 0 1.422.148 1.999.442a4.275 4.275 0 0 1 1.431 1.164c.379.481.663 1.03.856 1.649a6.353 6.353 0 0 1 0 3.79 5.099 5.099 0 0 1-.856 1.648 4.24 4.24 0 0 1-1.431 1.163c-.577.296-1.244.443-1.999.443-.754 0-1.42-.144-1.998-.432zm8.736.206V105.2h1.441l.124.865c.26-.275.597-.529 1.01-.762a2.53 2.53 0 0 1 1.256-.35c.303 0 .58.02.834.061.254.041.45.083.587.124l-.288 1.462c-.343-.15-.777-.226-1.298-.226-.398 0-.779.11-1.143.329-.364.22-.677.447-.937.68v7.643zm12.75-5.706h3.914l-1.998-5.254zm-3.831 5.706l5.293-13.74h1.01l5.398 13.74h-1.793l-1.627-4.244h-4.987l-1.564 4.244zm12.915 0h1.586v-13.74h-1.586zm4.223 0h1.585v-13.74h-1.585zM48.885 46.062v-7.595l-2.003 1.281-.52-.734 2.67-1.763h.935v8.811zm7.45-4.084c.275-.107.529-.245.76-.415.053-.302.08-.622.08-.96 0-.285-.027-.582-.08-.889a2.835 2.835 0 0 0-.286-.847 1.843 1.843 0 0 0-.555-.635c-.231-.164-.52-.247-.867-.247a1.51 1.51 0 0 0-.741.174c-.21.115-.383.27-.52.46a2.144 2.144 0 0 0-.314.648 2.572 2.572 0 0 0-.107.734c0 .286.038.555.112.809.076.253.188.477.334.673.148.196.334.352.561.468.228.115.492.172.794.172.286 0 .561-.048.828-.145zm-2.898 3.39c.4-.089.783-.218 1.148-.387a4.64 4.64 0 0 0 1.79-1.434 3.89 3.89 0 0 0 .547-1.009 2.899 2.899 0 0 1-1.63.481c-.417 0-.786-.082-1.107-.247a2.458 2.458 0 0 1-.814-.668 2.998 2.998 0 0 1-.507-.955 3.59 3.59 0 0 1-.174-1.12c0-.41.062-.792.187-1.148.125-.357.305-.668.54-.935a2.567 2.567 0 0 1 1.983-.868c.49 0 .916.1 1.281.3.366.2.666.467.901.801.236.333.412.713.528 1.136.116.421.173.855.173 1.3 0 .713-.111 1.382-.334 2.01a5.564 5.564 0 0 1-.94 1.682 5.324 5.324 0 0 1-1.462 1.235 5.607 5.607 0 0 1-1.896.668zm8.53.694v-7.595l-2.002 1.281-.52-.734 2.67-1.763h.934v8.811zm5.074-5.913a1.563 1.563 0 0 0 .9.793 1.705 1.705 0 0 0 1.688-.314 1.506 1.506 0 0 0 .52-1.174 1.45 1.45 0 0 0-.138-.654 1.38 1.38 0 0 0-.375-.467 1.54 1.54 0 0 0-.52-.274 1.924 1.924 0 0 0-1.167.007 1.62 1.62 0 0 0-.521.273 1.388 1.388 0 0 0-.52 1.115c-.001.258.044.49.133.695zm-.12 4.231c.105.204.244.376.413.514.169.138.36.242.574.314a2.008 2.008 0 0 0 1.275.006 1.6 1.6 0 0 0 .961-.82c.102-.206.154-.45.154-.734 0-.277-.052-.521-.154-.734a1.747 1.747 0 0 0-.981-.895 1.82 1.82 0 0 0-.641-.121 1.873 1.873 0 0 0-1.201.462 1.627 1.627 0 0 0-.561 1.26c0 .285.054.534.16.748zm-.869-2.002c.214-.382.535-.684.962-.908a2.667 2.667 0 0 1-.835-.88 2.203 2.203 0 0 1-.313-1.136c0-.4.077-.747.234-1.042.155-.292.36-.54.613-.74.254-.2.539-.349.855-.447a3.254 3.254 0 0 1 1.936 0c.315.098.598.243.847.434s.45.431.601.72.226.626.226 1.009c0 .426-.1.816-.3 1.168-.2.351-.47.652-.808.9.41.206.721.506.935.902.214.396.32.82.32 1.274 0 .437-.08.818-.24 1.142a2.46 2.46 0 0 1-.634.815c-.263.218-.56.38-.894.488a3.328 3.328 0 0 1-1.022.159c-.347 0-.687-.053-1.02-.16a2.737 2.737 0 0 1-.902-.487 2.415 2.415 0 0 1-.64-.815c-.161-.324-.241-.7-.241-1.127 0-.464.107-.886.32-1.269zM46.31 61.597v-.627c.49-.561.956-1.1 1.402-1.616a38.9 38.9 0 0 0 1.228-1.496c.213-.276.405-.53.574-.767.169-.235.31-.462.427-.68a3.21 3.21 0 0 0 .26-.641c.058-.21.087-.43.087-.661 0-.508-.132-.893-.394-1.155-.263-.262-.607-.393-1.035-.393-.81 0-1.473.444-1.988 1.334l-.841-.494c.31-.57.703-1.01 1.175-1.321.47-.311 1.045-.467 1.722-.467.382 0 .727.057 1.034.172a2.196 2.196 0 0 1 1.295 1.236c.12.29.18.608.18.955 0 .578-.143 1.123-.427 1.635a11.673 11.673 0 0 1-1.014 1.516c-.348.453-.708.891-1.082 1.313-.374.423-.748.84-1.121 1.25h3.87v.907zm7.569-1.923c.17.348.383.628.641.841.257.214.57.32.934.32.356 0 .663-.106.921-.32s.47-.493.635-.84c.165-.347.287-.738.366-1.176.081-.435.12-.875.12-1.32 0-.445-.037-.884-.113-1.316a4.237 4.237 0 0 0-.367-1.155 2.452 2.452 0 0 0-.64-.82 1.416 1.416 0 0 0-.922-.314c-.365 0-.677.105-.934.314a2.44 2.44 0 0 0-.641.82 4.18 4.18 0 0 0-.367 1.155 7.522 7.522 0 0 0 .006 2.636c.08.438.201.829.361 1.175zm.147 1.71c-.392-.268-.719-.617-.981-1.049s-.457-.92-.58-1.467a7.493 7.493 0 0 1-.188-1.677c0-.57.062-1.128.187-1.675a4.886 4.886 0 0 1 .58-1.469c.263-.431.593-.779.988-1.04.396-.263.87-.394 1.422-.394.543 0 1.015.131 1.415.394.4.261.732.609.994 1.04.264.432.457.922.582 1.469.124.547.186 1.106.186 1.675 0 .57-.064 1.128-.193 1.677a5.175 5.175 0 0 1-.58 1.467c-.26.432-.588.78-.989 1.048-.4.267-.872.4-1.415.4-.552 0-1.027-.133-1.428-.4zm7.943.213v-7.596l-2.003 1.282-.52-.735 2.67-1.763h.934v8.812zm5.073-5.914a1.579 1.579 0 0 0 .9.794 1.705 1.705 0 0 0 1.688-.314 1.507 1.507 0 0 0 .52-1.175c.001-.249-.045-.466-.138-.653a1.383 1.383 0 0 0-.375-.468 1.538 1.538 0 0 0-.52-.273 1.924 1.924 0 0 0-1.167.007 1.62 1.62 0 0 0-.521.273 1.384 1.384 0 0 0-.52 1.114c-.001.259.044.49.133.695zm-.12 4.232c.105.204.244.376.413.514.169.138.36.242.574.313a2.008 2.008 0 0 0 1.275.007 1.594 1.594 0 0 0 .961-.82c.102-.206.154-.45.154-.735 0-.276-.052-.52-.154-.734a1.744 1.744 0 0 0-.407-.547 1.786 1.786 0 0 0-.574-.347 1.82 1.82 0 0 0-.641-.122c-.214 0-.425.042-.634.122-.21.08-.398.192-.567.34a1.627 1.627 0 0 0-.561 1.261c0 .285.054.534.16.748zm-.869-2.002c.214-.383.535-.686.962-.909a2.675 2.675 0 0 1-.835-.88 2.204 2.204 0 0 1-.313-1.136c0-.4.077-.747.234-1.041.155-.294.36-.54.613-.741.254-.2.539-.348.855-.447a3.254 3.254 0 0 1 1.936 0c.315.099.598.243.847.434.249.192.45.432.601.721s.226.626.226 1.008c0 .427-.1.817-.3 1.168-.2.352-.47.652-.808.901.41.205.721.506.935.9.214.398.32.822.32 1.276 0 .437-.08.818-.24 1.141-.16.325-.372.597-.634.815a2.65 2.65 0 0 1-.894.487 3.329 3.329 0 0 1-2.043 0 2.722 2.722 0 0 1-.9-.487 2.403 2.403 0 0 1-.641-.815c-.161-.323-.241-.7-.241-1.127 0-.463.107-.885.32-1.268zm5.555-8.149h-24.75a.42.42 0 1 1 0-.841h24.75a.42.42 0 0 1 0 .841",
	  fill: "#4fb6ae"
	}), _react2.default.createElement("path", {
	  d: "M116.364 35.913l1.041 8.5 4.22-7.452-2.29 8.25 6.75-5.27-5.27 6.749 8.25-2.289-7.454 4.218 8.5 1.043-8.5 1.045 7.455 4.217-8.252-2.287 5.272 6.75-6.75-5.273 2.288 8.253-4.219-7.455-1.04 8.5-1.046-8.5-4.219 7.455 2.29-8.253-6.75 5.273 5.272-6.75-8.256 2.287 7.454-4.217-8.498-1.045 8.498-1.043-7.454-4.218 8.256 2.289-5.272-6.749 6.75 5.27-2.29-8.25 4.22 7.451z",
	  fill: "#1a466e"
	}), _react2.default.createElement("path", {
	  d: "M115.797 52.504l.567 4.607.565-4.607 2.283 4.039-1.24-4.47 3.658 2.856-2.856-3.653 4.467 1.237-4.035-2.284 4.603-.567-4.603-.565 4.035-2.284-4.467 1.239 2.856-3.654-3.658 2.855 1.24-4.471-2.283 4.038-.565-4.604-.567 4.603-2.283-4.037 1.237 4.47-3.656-2.854 2.858 3.654-4.473-1.24 4.037 2.285-4.602.565 4.602.567-4.037 2.284 4.473-1.237-2.858 3.653 3.656-2.855-1.237 4.469zm.567 15.286l-1.378-11.206-5.563 9.827 3.018-10.878-8.895 6.949 6.948-8.898L99.616 56.6l9.825-5.56-11.206-1.378 11.206-1.376-9.825-5.56 10.878 3.017-6.948-8.898 8.895 6.95-3.018-10.879 5.563 9.826 1.378-11.206 1.376 11.206 5.558-9.826-3.016 10.88 8.9-6.95-6.952 8.897 10.88-3.017-9.825 5.56 11.206 1.376-11.206 1.378 9.826 5.56-10.88-3.016 6.95 8.898-8.899-6.951 3.018 10.88-5.56-9.827z",
	  fill: "#fffffe"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 360 120"
	  }, props), _ref);
	};
	
	exports.default = __webpack_require__.p + "static/cmwf-logo.03302bc2.svg";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(377);
	
	var _reactEmotion = __webpack_require__(1230);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactCollapse = __webpack_require__(1166);
	
	var _ThemeList = __webpack_require__(64);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _iconMenu = __webpack_require__(580);
	
	var _iconMenu2 = _interopRequireDefault(_iconMenu);
	
	var _iconClose = __webpack_require__(578);
	
	var _iconClose2 = _interopRequireDefault(_iconClose);
	
	var _iconArrow = __webpack_require__(392);
	
	var _iconArrow2 = _interopRequireDefault(_iconArrow);
	
	var _app = __webpack_require__(184);
	
	var _NavigationModule = __webpack_require__(845);
	
	var _NavigationModule2 = _interopRequireDefault(_NavigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//  Components
	
	
	//  Styles
	
	
	var Navigation = function (_React$Component) {
	  _inherits(Navigation, _React$Component);
	
	  function Navigation() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navigation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isTrendsShown: true,
	      isStatesShown: false,
	      isAlphabetical: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Navigation.prototype.handleTrendsClick = function handleTrendsClick(e) {
	    this.setState({ isTrendsShown: !this.state.isTrendsShown });
	    e.preventDefault();
	  };
	
	  Navigation.prototype.handleStatesClick = function handleStatesClick(e) {
	    this.setState({ isStatesShown: !this.state.isStatesShown });
	    e.preventDefault();
	  };
	
	  Navigation.prototype.handleOrderChange = function handleOrderChange(e) {
	    this.setState({ isAlphabetical: e.target.value === "Alphabetical" ? true : false });
	    e.preventDefault();
	  };
	
	  Navigation.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        isDrawerOpen = _props.isDrawerOpen,
	        toggleDrawer = _props.toggleDrawer,
	        themes = _props.themes,
	        states = _props.states;
	
	    var isTrendsShown = this.state.isTrendsShown;
	    var isStatesShown = this.state.isStatesShown;
	    var isAlphabetical = this.state.isAlphabetical;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _NavigationModule2.default.menu_toggle },
	        _react2.default.createElement(
	          'button',
	          { className: isDrawerOpen ? _NavigationModule2.default.menu__open : _NavigationModule2.default.menu__closed,
	            onClick: function onClick() {
	              return toggleDrawer(!isDrawerOpen);
	            }
	          },
	          _react2.default.createElement(_iconMenu.ReactComponent, { className: isDrawerOpen ? _NavigationModule2.default.icon__hidden : _NavigationModule2.default.icon__shown }),
	          _react2.default.createElement(_iconClose.ReactComponent, { className: !isDrawerOpen ? _NavigationModule2.default.icon__hidden : _NavigationModule2.default.icon__shown }),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Menu'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: [_NavigationModule2.default.menu, isDrawerOpen ? _NavigationModule2.default.menu__open : _NavigationModule2.default.menu__closed].join(' ') },
	        _react2.default.createElement(
	          'button',
	          { className: _NavigationModule2.default.menu__close__icon, onClick: function onClick() {
	              return toggleDrawer(!isDrawerOpen);
	            } },
	          _react2.default.createElement(_iconClose.ReactComponent, null)
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: _NavigationModule2.default.menu__primary },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { exact: true, to: '/', onClick: function onClick() {
	                  return toggleDrawer(!isDrawerOpen);
	                }, className: _NavigationModule2.default.menu__primary__link, activeClassName: _NavigationModule2.default.menu__primary__link__active },
	              'Overview'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h3',
	              { className: _NavigationModule2.default.menu__secondary__title + ' ' + _NavigationModule2.default.menu__secondary__title__spaced },
	              _react2.default.createElement(
	                'button',
	                { className: [_NavigationModule2.default.menu__secondary__toggle, isTrendsShown ? _NavigationModule2.default.menu__secondary__toggle__open : _NavigationModule2.default.menu__secondary__toggle__closed].join(" "), onClick: function onClick(e) {
	                    return _this2.handleTrendsClick(e);
	                  } },
	                'Trends ',
	                _react2.default.createElement(_iconArrow.ReactComponent, null)
	              )
	            ),
	            _react2.default.createElement(
	              _reactCollapse.Collapse,
	              { isOpened: isTrendsShown },
	              _react2.default.createElement(_ThemeList2.default, { themes: themes, className: _NavigationModule2.default.menu__secondary, linkClassName: _NavigationModule2.default.menu__secondary__link, activeClassName: _NavigationModule2.default.menu__secondary__link__active, onLinkClick: function onLinkClick() {
	                  return toggleDrawer(!isDrawerOpen);
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { exact: true, to: '/highlights', onClick: function onClick() {
	                  return toggleDrawer(!isDrawerOpen);
	                }, className: _NavigationModule2.default.menu__primary__link, activeClassName: _NavigationModule2.default.menu__primary__link__active },
	              'Highlights'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'h3',
	              { className: _NavigationModule2.default.menu__secondary__title },
	              _react2.default.createElement(
	                'button',
	                { className: [_NavigationModule2.default.menu__secondary__toggle, isStatesShown ? _NavigationModule2.default.menu__secondary__toggle__open : _NavigationModule2.default.menu__secondary__toggle__closed].join(" "), onClick: function onClick(e) {
	                    return _this2.handleStatesClick(e);
	                  } },
	                'States ',
	                _react2.default.createElement(_iconArrow.ReactComponent, null)
	              )
	            ),
	            _react2.default.createElement(
	              _reactCollapse.Collapse,
	              { isOpened: isStatesShown },
	              _react2.default.createElement(
	                'div',
	                { className: _NavigationModule2.default.states__sorting__options },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'state--sort-select' },
	                  'Sort States:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    id: 'state--sort-select',
	                    value: isAlphabetical ? "Alphabetical" : "Ranking",
	                    className: 'select__small select__small__dark', onChange: function onChange(e) {
	                      return _this2.handleOrderChange(e);
	                    } },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Alphabetical' },
	                    'Alphabetical'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Ranking' },
	                    'Ranking'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: [_NavigationModule2.default.menu__secondary, _NavigationModule2.default.menu__states].join(" ") },
	                states.sort(isAlphabetical ? function (a, b) {
	                  return a.node.title == b.node.title ? 0 : +(a.node.title > b.node.title) || -1;
	                } : function (a, b) {
	                  return a.node.ranking - b.node.ranking;
	                }).map(function (node, index) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: node.node.id },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      {
	                        to: '/state/' + node.node.url,
	                        onClick: function onClick() {
	                          return toggleDrawer(!isDrawerOpen);
	                        },
	                        className: [_NavigationModule2.default.menu__secondary__link, _NavigationModule2.default.menu__states__link].join(" "),
	                        activeClassName: _NavigationModule2.default.menu__secondary__link__active },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        node.node.ranking
	                      ),
	                      node.node.title
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { exact: true, to: '/conclusion', onClick: function onClick() {
	                  return toggleDrawer(!isDrawerOpen);
	                }, className: _NavigationModule2.default.menu__primary__link, activeClassName: _NavigationModule2.default.menu__primary__link__active },
	              'Conclusion'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { exact: true, to: '/methodology', onClick: function onClick() {
	                  return toggleDrawer(!isDrawerOpen);
	                }, className: _NavigationModule2.default.menu__primary__link, activeClassName: _NavigationModule2.default.menu__primary__link__active },
	              'Methodology'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2018.pdf'), onClick: function onClick() {
	                  return toggleDrawer(!isDrawerOpen);
	                }, className: _NavigationModule2.default.menu__primary__link },
	              'PDF Download'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'http://datacenter.commonwealthfund.org', className: _NavigationModule2.default.menu__primary__link },
	              'Data Center'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', {
	        className: [_NavigationModule2.default.menu__cover, isDrawerOpen ? _NavigationModule2.default.menu__open : _NavigationModule2.default.menu__closed].join(' '),
	        onClick: function onClick() {
	          return toggleDrawer(!isDrawerOpen);
	        } })
	    );
	  };
	
	  return Navigation;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { isDrawerOpen: state.app.isDrawerOpen };
	}, function (dispatch) {
	  return { toggleDrawer: function toggleDrawer(open) {
	      return dispatch((0, _app.toggleDrawer)(open));
	    } };
	})(Navigation);
	module.exports = exports['default'];

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu_toggle":"src-components-Navigation----Navigation-module---menu_toggle---3q2bS","icon__shown":"src-components-Navigation----Navigation-module---icon__shown---1Qlwg","icon__hidden":"src-components-Navigation----Navigation-module---icon__hidden---1xTzG","menu":"src-components-Navigation----Navigation-module---menu---3Mvl9","menu__open":"src-components-Navigation----Navigation-module---menu__open---1xNbw","menu__close__icon":"src-components-Navigation----Navigation-module---menu__close__icon---3gRFr","menu__primary":"src-components-Navigation----Navigation-module---menu__primary---1Yh3o","menu__primary__link":"src-components-Navigation----Navigation-module---menu__primary__link---3_o0P","menu__primary__link__active":"src-components-Navigation----Navigation-module---menu__primary__link__active---3aw3M","menu__secondary":"src-components-Navigation----Navigation-module---menu__secondary---3D8G3","menu__states":"src-components-Navigation----Navigation-module---menu__states---3_cNE","menu__secondary__link":"src-components-Navigation----Navigation-module---menu__secondary__link---2OhX-","menu__secondary__link__active":"src-components-Navigation----Navigation-module---menu__secondary__link__active---2Tu9F","menu__states__link":"src-components-Navigation----Navigation-module---menu__states__link---7G1gw","menu__cover":"src-components-Navigation----Navigation-module---menu__cover---3JeZe","menu__closed":"src-components-Navigation----Navigation-module---menu__closed---hV9ys","menu__secondary__title":"src-components-Navigation----Navigation-module---menu__secondary__title---1GlTw","menu__secondary__toggle":"src-components-Navigation----Navigation-module---menu__secondary__toggle---33b7U","menu__secondary__toggle__open":"src-components-Navigation----Navigation-module---menu__secondary__toggle__open---26wcb","menu__secondary__toggle__closed":"src-components-Navigation----Navigation-module---menu__secondary__toggle__closed---1y_cA","states__sorting__options":"src-components-Navigation----Navigation-module---states__sorting__options---1Ee8m","select__small__dark":"src-components-Navigation----Navigation-module---select__small__dark---1j0u_"};

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactShare = __webpack_require__(515);
	
	var _iconEmail = __webpack_require__(393);
	
	var _iconEmail2 = _interopRequireDefault(_iconEmail);
	
	var _iconTwitter = __webpack_require__(396);
	
	var _iconTwitter2 = _interopRequireDefault(_iconTwitter);
	
	var _iconFacebook = __webpack_require__(394);
	
	var _iconFacebook2 = _interopRequireDefault(_iconFacebook);
	
	var _iconLinkedin = __webpack_require__(395);
	
	var _iconLinkedin2 = _interopRequireDefault(_iconLinkedin);
	
	var _ShareModule = __webpack_require__(847);
	
	var _ShareModule2 = _interopRequireDefault(_ShareModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//  Components
	
	
	//  Styles
	
	
	// const Share = ({ location, social }) => (
	var Share = function (_React$Component) {
	  _inherits(Share, _React$Component);
	
	  function Share() {
	    _classCallCheck(this, Share);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Share.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        social = _props.social,
	        site = _props.site;
	
	
	    var sharePath = site.siteUrl;
	    var shareTitle = site.title;
	    var shareDescription = site.siteDescription;
	    var emailTitle = site.title;
	
	    var prefix = site.siteUrl;
	    if (site.siteUrl === "/") {
	      prefix = "";
	    }
	
	    var currentNode = social.filter(function (node) {
	      return location.pathname.includes(node.node.path);
	    })[0];
	
	    if (currentNode !== undefined) {
	      var node = currentNode.node;
	
	      sharePath = prefix + node.path;
	      if (node.path[0] !== "/") {
	        sharePath = node.path;
	      }
	
	      if (node.share_path.length > 0) {
	        sharePath = node.share_path;
	      }
	
	      if (node.title.length > 0) {
	        shareTitle = node.title + '\n' + shareTitle;
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _ShareModule2.default.share },
	      _react2.default.createElement(
	        'h2',
	        { className: _ShareModule2.default.share_title },
	        'Share'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: _ShareModule2.default.share_list },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactShare.EmailShareButton,
	              { subject: emailTitle, body: shareTitle + '\n\n' + shareDescription + '\n\n' + sharePath, quote: shareTitle, url: sharePath, className: _ShareModule2.default.share_list_icon },
	              _react2.default.createElement(_iconEmail.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactShare.TwitterShareButton,
	              { via: 'commonwealthfnd', quote: shareTitle, title: shareTitle, url: sharePath, className: _ShareModule2.default.share_list_icon },
	              _react2.default.createElement(_iconTwitter.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactShare.FacebookShareButton,
	              { quote: shareTitle, url: sharePath, className: _ShareModule2.default.share_list_icon },
	              _react2.default.createElement(_iconFacebook.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactShare.LinkedinShareButton,
	              { title: shareTitle, description: shareDescription, quote: shareTitle, url: sharePath, className: _ShareModule2.default.share_list_icon },
	              _react2.default.createElement(_iconLinkedin.ReactComponent, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Share;
	}(_react2.default.Component);
	
	exports.default = Share;
	module.exports = exports['default'];

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"share":"src-components-Share----Share-module---share---3hhFg","share_title":"src-components-Share----Share-module---share_title---28Ih1","share_list":"src-components-Share----Share-module---share_list---1M8c9","share_list_icon":"src-components-Share----Share-module---share_list_icon---3QgS7"};

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(126);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(377);
	
	var _app = __webpack_require__(184);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _Header = __webpack_require__(540);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(539);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(1161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data,
	      isDrawerOpen = _ref.isDrawerOpen,
	      location = _ref.location,
	      toggleDrawer = _ref.toggleDrawer;
	
	  var isHomepage = location.pathname === (0, _gatsbyLink.withPrefix)("/");
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: data.site.siteMetadata.title,
	        meta: [{ name: 'description', content: data.site.siteMetadata.siteDescription }],
	        htmlAttributes: {
	          class: isDrawerOpen ? 'menu-open' : 'menu-closed'
	        },
	        link: [{ rel: 'icon', type: 'image/png', href: (0, _gatsbyLink.withPrefix)("/favicon.ico") }]
	      },
	      _react2.default.createElement('script', { src: 'https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: data.site.siteMetadata.title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: data.site.siteMetadata.siteDescription }),
	      _react2.default.createElement('meta', { property: 'og:url', content: '' + data.site.siteMetadata.siteUrl }),
	      _react2.default.createElement('meta', { property: 'og:image', content: data.site.siteMetadata.siteUrl + '/2018-state-health-system-scorecard-share.png' }),
	      _react2.default.createElement('meta', { property: 'og:image:url', content: data.site.siteMetadata.siteUrl + '/2018-state-health-system-scorecard-share.png' }),
	      _react2.default.createElement('meta', { property: 'og:image:type', content: 'image/png' }),
	      _react2.default.createElement('meta', { property: 'og:image:width', content: '1200' }),
	      _react2.default.createElement('meta', { property: 'og:image:height', content: '630' }),
	      _react2.default.createElement('meta', { property: 'og:locale', content: 'en_US' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: data.site.siteMetadata.siteDescription }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: data.site.siteMetadata.title }),
	      _react2.default.createElement('meta', { name: 'twitter:site', content: '@commonwealthfnd' }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: data.site.siteMetadata.siteUrl + '/2018-state-health-system-scorecard-share.png' })
	    ),
	    _react2.default.createElement(_Header2.default, {
	      siteYear: data.site.siteMetadata.year,
	      siteSubtitle: data.site.siteMetadata.subtitle,
	      site: data.site.siteMetadata,
	      isHome: isHomepage,
	      themes: data.allThemesJson.edges,
	      states: data.allStatesJson.edges,
	      social: data.allSocialJson.edges,
	      location: location }),
	    _react2.default.createElement(
	      'div',
	      { className: 'l-container' },
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { isDrawerOpen: state.app.isDrawerOpen };
	}, function (dispatch) {
	  return { toggleDrawer: function toggleDrawer(open) {
	      return dispatch((0, _app.toggleDrawer)(open));
	    } };
	})(Layout);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 1161:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9542281691f31ac8fd74.js